export default {
  首页: "trang đầu",
  资产: "tài sản",
  币币: "Tiền tệ",
  快捷买币: "Nhanh tay mua xu",
  "支持多种方式购买，购买更简单":
    "Hỗ trợ nhiều cách mua hàng, dễ dàng mua hàng hơn",
  语言设置: "cài đặt ngôn ngữ",
  确认恢复: "xác nhận phục hồi",
  "输入邮箱，方便我们联系您":
    "Nhập email của bạn để chúng tôi có thể liên lạc với bạn",
  划转: "chuyển khoản",
  行情: "báo giá",
  "24H成交": "giao dịch 24H",
  累计收益: "thu nhập tích lũy",
  充值时间: "thời gian sạc lại",
  到期时间: "Hạn sử dụng",
  数量: "số lượng",
  操作: "vận hành",
  资产信息: "thông tin tài sản",
  复制地址: "sao chép địa chỉ",
  链名称: "chuỗi tên",
  充值地址: "địa chỉ nạp tiền",
  收款地址: "địa chỉ nhận",
  账单: "hóa đơn",
  提现金额: "Số tiền rút",
  接收地址: "địa chỉ nhận",
  交易密码: "Mật khẩu giao dịch",
  提现全部: "Rút tất cả",
  保存图片: "lưu hình ảnh",
  输入您的交易密码: "Nhập mật khẩu giao dịch của bạn",
  确定: "Chắc chắn rồi",
  地址: "địa chỉ",
  注册时间: "Thời gian đăng ký",
  取消: "Hủy bỏ",
  是否划转: "có chuyển không",
  登录: "Đăng nhập",
  我的地址: "địa chỉ của tôi",
  登录密码和交易密码: "Mật khẩu đăng nhập và mật khẩu giao dịch",
  注册: "Đăng ký",
  密码: "mật khẩu mở khóa",
  设置密码: "đặt mật khẩu",
  重复密码: "lặp lại mật khẩu",
  新密码: "mật khẩu mới",
  确认新密码: "Xác nhận mật khẩu mới",
  充值: "nạp điện",
  充值货币: "Nạp tiền tệ",
  合约账户充值: "Nạp tiền vào tài khoản hợp đồng",
  账户充值: "nạp tiền vào tài khoản",
  其他: "khác",
  我的邀请码: "mã mời của tôi",
  提现: "rút",
  客服: "dịch vụ khách hàng",
  持有详情: "giữ chi tiết",
  请输入内容: "Vui lòng nhập nội dung",
  邀请好友来领取奖励: "Mời bạn bè nhận phần thưởng",
  复制链接: "sao chép đường dẫn",
  重复设置新的密码: "Lặp lại để đặt mật khẩu mới",
  保存: "tiết kiệm",
  我的: "của tôi",
  "邮箱/手机号": "Email/Số di động",
  备注: "Nhận xét",
  地址管理: "quản lý địa chỉ",
  我的团队: "đội của tôi",
  联系我们: "liên hệ chúng tôi",
  竭诚为您服务: "Trân trọng tại dịch vụ của bạn",
  提取收益: "Rút tiền",
  带给我的收益: "lợi ích cho tôi",
  添加: "Thêm vào",
  名称: "Tên",
  添加地址: "thêm địa chỉ",
  修改地址: "Thay đổi địa chỉ",
  可提现: "Có thể rút tiền",
  安全中心: "Trung tâm bảo vệ",
  收益划转: "chuyển tiền thu được",
  通知中心: "Trung tâm Thông báo",
  "累计收益:": "Thu nhập tích lũy:",
  注册用户: "người dùng đã đăng ký",
  奖励规则: "quy tắc khen thưởng",
  帮助反馈: "phản hồi trợ giúp",
  邀请好友: "mời bạn bè",
  恢复身份: "khôi phục danh tính",
  选择语言: "Chọn một ngôn ngữ",
  设置新的密码: "đặt mật khẩu mới",
  暂无活动: "chưa có hoạt động nào",
  "月增长量(+)": "Tăng trưởng hàng tháng (+)",
  可提取: "có thể trích xuất",
  反馈类型: "Loại phản hồi",
  赠送: "quà tặng",
  已经复制: "đã được sao chép",
  保存成功: "Lưu thành công",
  划转成功: "chuyển thành công",
  过期: "Hết hạn",
  提交成功: "gửi thành công",
  "服务器繁忙，稍后在试": "Máy chủ đang bận, hãy thử lại sau",
  全部: "tối đa",
  一级: "cấp một",
  二级: "Sơ trung",
  三级: "cấp ba",
  级: "lớp",
  删除成功: "xóa thành công",
  选择地址: "chọn địa chỉ",
  不再提醒: "không nhắc nhở",
  "最小充值金额：": "Số tiền nạp tối thiểu:",
  选择币种: "chọn tiền tệ",
  输入投资金额: "Nhập số tiền đầu tư",
  输入账户密码: "Nhập mật khẩu tài khoản",
  投资: "đầu tư",
  订单编号: "số thứ tự",
  投资周期: "chu kỳ đầu tư",
  投资资金: "Quỹ đầu tư",
  投资时间: "thời gian đầu tư",
  状态: "tiểu bang",
  投资中: "đầu tư",
  已到期: "hết hạn",
  暂无数据: "Không có dữ liệu",
  转入: "chuyển giao",
  邮箱: "Thư",
  请输入邮箱: "vui lòng nhập email của bạn",
  请输入格式正确的邮箱: "Vui lòng nhập địa chỉ email theo đúng định dạng",
  请输入验证码: "vui lòng nhập mã xác nhận",
  获取验证码: "lấy mã xác minh",
  请输入邀请码: "Vui lòng nhập mã thư mời",
  今天: "hôm nay",
  昨天: "hôm qua",
  最近七天: "bảy ngày qua",
  邀请: "mời",
  购买数量: "Số lượng mua",
  产品详情: "Thông tin chi tiết sản phẩm",
  币种: "Tiền tệ",
  利息币种: "Tiền lãi",
  理财类型: "Loại hình quản lý tài chính",
  产品费率: "tỷ lệ sản phẩm",
  进行中: "Chế biến",
  每天: "Hằng ngày",
  请输入搜索关键词: "Vui lòng nhập từ khóa tìm kiếm",
  通知: "Để ý",
  查看更多: "xem thêm",
  理财宝: "Kho báu tiền bạc",
  周期: "đi xe đạp",
  年利率: "lãi suất hàng năm",
  更多产品: "nhiều sản phẩm hơn",
  灵活存取: "truy cập linh hoạt",
  稳定收益: "thu nhập ổn định",
  合约指南: "Hướng dẫn hợp đồng",
  资金划转出: "chuyển tiền ra",
  矿池收益: "Thu nhập nhóm khai thác",
  提现手续费: "Phí rút tiền",
  冻结资金: "đóng băng tiền",
  解冻资金: "giải phóng quỹ",
  闪兑支出: "thanh toán ngay lập tức",
  闪兑收入: "Thu nhập tức thì",
  闪兑手续费: "phí tức thì",
  合约支出: "thanh toán hợp đồng",
  合约收入: "thu nhập hợp đồng",
  输入的金额不可大于可用金额:
    "Số tiền đã nhập không được lớn hơn số tiền khả dụng",
  全部兑换成功: "Tất cả đã đổi thành công",
  返回: "trở về",
  查看历史: "xem lịch sử",
  闪兑历史: "Lịch sử flash",
  支付: "trả",
  获取: "Được",
  时间: "thời gian",
  手续费: "phí xử lý",
  折扣: "Miễn giảm",
  价格: "giá bán",
  逐仓: "Bị cô lập",
  全仓: "Đi qua",
  市价委托: "Đặt hàng ở siêu thị",
  限价委托: "lệnh giới hạn",
  请输入本金: "Số lượng",
  请输入价格: "Giá bán",
  "可做空/做多": "Có thể đi ngắn / dài",
  设置止盈止损: "TP/SL",
  止盈价: "Est. TP",
  止损价: "Est. SL",
  成本: "Giá cả",
  做多: "Dài",
  做空: "ngắn",
  仓位信息: "Thông tin vị trí",
  一键平仓: "Đóng tất cả",
  永续: "bền vững",
  浮动盈亏: "Lãi lỗ thả nổi",
  平仓: "đóng một vị trí",
  反向开仓: "mở ngược",
  一键撤销: "Hoàn tác bằng một cú nhấp chuột",
  倍杠杆: "đòn bẩy kép",
  执行价格: "giá thực hiện",
  委托数量: "Số lượng đặt hàng",
  保证金: "Lề",
  成交价: "giá niêm yết",
  创建时间: "thời gian sáng tạo",
  撤销: "thu hồi",
  合约市场: "thị trường hợp đồng",
  交易方向: "hướng giao dịch",
  委托价格: "giá hoa hồng",
  委托金额: "số tiền ủy thác",
  资金费率: "tỷ lệ tài trợ",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Một khoản phí định kỳ được trả bởi các nhà giao dịch mua và bán, được thanh toán 8 giờ một lần.",
  "资金费率为正，多方向空方支付资金费用。":
    "Tỷ lệ tài trợ là dương và phe mua trả phí tài trợ cho phe bán.",
  "资金费率为负，空方向多方支付资金费用。":
    "Tỷ lệ cấp vốn là âm và bên bán trả phí cấp vốn cho bên mua.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Bạn có chắc chắn để mở một vị trí đảo ngược? Mở một vị trí đảo ngược sẽ sử dụng vị trí ngược lại của giai đoạn hiện tại để mua",
  "仓位止盈/止损": "Vị thế Chốt lãi/Cắt lỗ",
  合约名称: "tên hợp đồng",
  开仓价格: "giá mở cửa",
  指数价格: "giá chỉ số",
  止盈设置: "Cài đặt chốt lời",
  请输入止盈价: "Vui lòng nhập giá chốt lời",
  "当指数价格触达*时，将会触发委托平仓":
    "Khi giá chỉ số đạt {0}, lệnh sẽ được kích hoạt để đóng vị thế",
  预计盈亏: "Lãi lỗ ước tính",
  当前仓位: "vị trí hiện tại",
  平仓金额: "số tiền đóng",
  仓位模式: "chế độ vị trí",
  全仓模式: "Chế độ ký quỹ chéo",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "Tất cả số tiền khả dụng trong tài khoản hợp đồng được coi là ký quỹ khả dụng. Khi tổn thất vị thế vượt quá số dư tài khoản, vị thế sẽ bị thanh lý và tất cả số tiền ký quỹ và vị thế sẽ bị mất. Xin lưu ý",
  逐仓模式: "Chế độ ký quỹ biệt lập",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Một số tiền ký quỹ nhất định trong tài khoản hợp đồng sẽ được phân bổ cho vị thế. Nếu mức lỗ ký quỹ thấp hơn mức ký quỹ duy trì, vị thế sẽ được thanh lý. Trong chế độ Ký quỹ riêng biệt, bạn có thể tăng và giảm ký quỹ cho vị thế này.",
  "是否撤销？": "Nó có bị thu hồi không?",
  "是否一键撤销？": "Có thể hoàn tác bằng một cú nhấp chuột không?",
  "是否一键平仓？": "Có thể đóng một vị trí với một cú nhấp chuột?",
  持仓保证金: "Lề",
  风险率: "tỷ lệ rủi ro",
  未实现盈亏: "chưa thực hiện P&L",
  可用保证金: "ký quỹ có sẵn",
  净值: "giá trị ròng",
  账户余额: "Số dư tài khoản",
  合约计算器: "Máy tính hợp đồng",
  交易记录: "Ghi lại giao dịch",
  "*倍杠杆": "{num} Đòn bẩy kép",
  "平仓盈亏：": "Chốt lãi lỗ:",
  时间筛选: "bộ lọc thời gian",
  仓位类型: "loại vị trí",
  订单状态: "Tình trạng đặt hàng",
  订单类型: "Kiểu đơn hàng",
  平仓价格: "Giá đóng cửa",
  持仓数量: "Số vị trí",
  "手续费(%)": "Phí (%)",
  平仓时间: "Thời gian đóng cửa",
  平仓类型: "loại đóng cửa",
  手动平仓: "Đóng các vị trí theo cách thủ công",
  强制平仓: "buộc thanh lý",
  近1天: "gần 1 ngày",
  近7天: "7 ngày qua",
  近30天: "30 ngày trước",
  近180天: "Gần 180 ngày",
  持仓: "Chức vụ",
  已取消: "Đã hủy",
  分时: "Thời gian",
  "24H额(USDT)": "Số tiền 24 giờ (USDT)",
  "24H低": "thấp nhất trong 24 giờ",
  "24H量(BTC)": "Số tiền 24 giờ (BTC)",
  "24H高": "cao 24H",
  "10秒": "10 giây",
  "30秒": "30 giây",
  "1分": "1 điểm",
  "3分": "3 điểm",
  "5分": "5 điểm",
  "30分": "30 điểm",
  "1小时": "1 giờ",
  "4小时": "4 tiếng",
  "8小时": "8 giờ",
  "1天": "1 ngày",
  "1周": "1 tuần",
  "1月": "tháng Giêng",
  单向持仓: "Vị trí một chiều",
  杠杆: "đòn bẩy",
  仓位: "Chức vụ",
  计算结果: "Kết quả tính toán",
  盈亏: "lợi nhuận và thua lỗ",
  收益率: "tỷ lệ lợi nhuận",
  计算结果仅供参考: "Kết quả tính toán chỉ mang tính chất tham khảo",
  成交后仓位大小: "Kích thước vị trí sau khi giao dịch",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Kết quả tính toán chỉ mang tính chất tham khảo, kết quả thực tế có thể thay đổi do tỷ lệ chênh lệch",
  目标价格: "giá mục tiêu",
  开始计算: "bắt đầu tính toán",
  强平价格: "giá thanh lý",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    " Trước khi nạp tiền, vui lòng kiểm tra kỹ tên của chuỗi nạp tiền. Không thể truy xuất tài sản nếu nạp sai. {0}Số tiền nạp tối thiểu là {1}; nền tảng sẽ không thể xác nhận tài khoản nếu ít hơn số tiền này. Vui lòng thực hiện không nạp tài sản khác với {2} vào địa chỉ này, nếu không bạn sẽ không thể lấy lại tài sản, vui lòng không trực tiếp rút tiền mặt đến địa chỉ gây quỹ cộng đồng hoặc ICO và Ping sẽ không phân phối tiền thay cho bạn.",
  "最小输入*": "Đầu vào tối thiểu{0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Số tiền rút tối thiểu là {0} và phí rút tiền sẽ được khấu trừ vào số tiền rút của bạn. Vui lòng xác nhận và kiểm tra địa chỉ nhận trước khi rút tiền và không rút {1}đến địa chỉ khác {2}, nếu không tài sản sẽ không được phục hồi. Vui lòng không trực tiếp rút tiền từ các địa chỉ gây quỹ cộng đồng hoặc ICO, nền tảng sẽ không xử lý việc phát hành mã thông báo.",
  退出登录: "đăng xuất",
  加仓: "tăng vị trí",
  新增仓位: "Vị trí mới",
  输入加仓金额: "Nhập số tiền tăng thêm",
  "当前可用:": "Hiện đang có sẵn:",
  资产账单: "hóa đơn tài sản",
  保存二维码: "Lưu mã QR",
  温馨提示: "lời khuyên tốt",
  "请注意：您当前使用的网络": "Lưu ý: mạng hiện tại của bạn",
  输入提现地址: "Nhập địa chỉ rút tiền",
  "可用金额：": "Số lượng có sẵn:",
  输入资产密码: "Nhập mật khẩu tài sản",
  可用手续费: "Phí có sẵn",
  "折扣%": "Miễn giảm%",
  实扣手续费: "Phí khấu trừ thực tế",
  实际到账: "Tài khoản thực tế",
  未设置资产密码: "Mật khẩu nội dung chưa được đặt",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Vì sự an toàn cho tài sản của bạn, vui lòng đặt mật khẩu tài sản trước khi rút tiền.",
  热榜: "Nóng",
  涨幅榜: "Nổi lên",
  跌幅榜: "Kẻ thua cuộc",
  成交额榜: "Doanh số",
  关于我们: "về chúng tôi",
  登录密码: "mật khẩu đăng nhập",
  设置: "cài đặt",
  资产密码: "mật khẩu tài sản",
  修改登录密码: "Thay đổi mật khẩu đăng nhập",
  原密码: "Mật khẩu cũ",
  请输入新密码: "Vui lòng nhập mật khẩu mới",
  请输入原密码: "Vui lòng nhập mật khẩu ban đầu",
  确认密码: "Xác nhận mật khẩu",
  确定修改: "OK để sửa đổi",
  修改资产密码: "Sửa đổi mật khẩu tài sản",
  验证码: "mã xác nhận",
  资产密码使用提示: "Mẹo sử dụng mật khẩu nội dung",
  "资产密码用于转移、提取资产和交易。":
    "Mật khẩu tài sản được sử dụng để chuyển, rút ​​tài sản và giao dịch.",
  "创建与登录密码不同的资产密码。":
    "Tạo mật khẩu nội dung khác với mật khẩu đăng nhập.",
  "定期更改您的资产密码。": "Thay đổi mật khẩu tài sản của bạn thường xuyên.",
  提币历史: "Lịch sử rút tiền",
  "金额/余额": "Số tiền/Số dư",
  "手续费/折扣": "Phí/Giảm giá",
  自选: "chọn",
  现货: "Điểm",
  市价: "Giá thị trường",
  止损设置: "Cài đặt dừng lỗ",
  合约K线图: "Biểu đồ nến hợp đồng",
  "24H量": "âm lượng 24H",
  "24H额": "lượng 24H",
  合作指南: "hướng dẫn hợp tác",
  盈亏计算: "tính lãi lỗ",
  当前可用: "hiện đang có sẵn",
  请输入加仓金额: "Vui lòng nhập số tiền tăng thêm",
  请重新输入加仓金额: "Vui lòng nhập lại số tiền tăng thêm",
  平仓数量: "Đóng số lượng",
  欢迎登录: "vui lòng đăng nhập",
  "忘记密码?": "Quên mật khẩu?",
  "还没有账号？": "Vẫn chưa có tài khoản?",
  立即注册: "Đăng ký ngay",
  繁體中文: "truyền thống Trung Quốc",
  找回密码: "lấy lại mật khẩu",
  下一步: "Bước tiếp theo",
  注册账户: "đăng ký tài khoản",
  "请输入邀请码(选填)": "Vui lòng nhập mã mời (không bắt buộc)",
  谢邀豪礼: "Cảm ơn vì lời mời",
  "24小时邀请好友排名": "Xếp hạng mời bạn bè trong 24 giờ",
  "*人": "{0}Mọi người",
  "差*人": "{0}Người nghèo",
  "已超过10万人，每月轻松赚钱":
    "Hơn 100.000 người, kiếm tiền dễ dàng hàng tháng",
  最高: "cao nhất",
  邀请链接: "liên kết mời",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Nền tảng chia sẻ với bạn phí xử lý do bạn bè trên nền tảng tạo ra (giao ngay, hợp đồng, đòn bẩy, trao đổi chớp nhoáng)",
  平台和您一起分享手续费: "Nền tảng chia sẻ phí xử lý với bạn",
  "*级": "{0}lớp",
  规则: "qui định",
  我的好友: "bạn tốt của tôi",
  好友详情: "chi tiết bạn bè",
  获得好友佣金方案: "Chương trình hoa hồng nhận bạn bè",
  我的等级: "lớp của tôi",
  我的邀请数据: "dữ liệu lời mời của tôi",
  当前等级: "cấp độ hiện tại",
  平台奖励您: "Nền tảng thưởng cho bạn",
  最高可获取平台奖励: "Phần thưởng nền tảng cao nhất có thể nhận được",
  邀请规则: "quy tắc mời",
  "邀请*级有效好友": "Mời bạn bè hợp lệ ở cấp độ {0}",
  好友等级: "mức độ bạn bè",
  人: "Mọi người",
  奖金派送: "giao hàng thưởng",
  平台奖励: "Phần thưởng nền tảng",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Quyền giải thích cuối cùng thuộc về nền tảng. Nếu phát hiện thấy bất thường để nhận phần thưởng nền tảng, tất cả phần thưởng sẽ bị khấu trừ và tài khoản sẽ bị đóng băng. Tài sản bị mất sẽ không được phục hồi.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Tài khoản của bạn phải là một tài khoản hợp lệ và nền tảng xác định rằng điều kiện tài khoản hợp lệ là (tài khoản nạp bất kỳ loại tiền tệ nào) tối thiểu {0} giá trị USDT.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Người bạn mà bạn mời phải là cấp dưới hợp lệ và nền tảng xác định rằng cấp dưới hợp lệ là giá trị tối thiểu {0} USDT (nạp tiền vào tài khoản bằng bất kỳ loại tiền tệ nào).",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Tài khoản của người mời và người được mời không được thuộc cùng một IP.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "Cấp độ VIP được đánh giá theo số lượng bạn bè cấp {0} mà bạn mời.",
  佣金成分: "thành phần hoa hồng",
  收益统计: "thống kê thu nhập",
  昨日收益: "Thu nhập của ngày hôm qua",
  月收益: "thu nhập hàng tháng",
  获取收益: "đạt được thu nhập",
  "总收益：": "Tổng doanh thu:",
  "*级好友": "{0} bạn cấp",
  理财购买: "mua tài chính",
  期限: "thuật ngữ",
  可用金额: "Số lượng có sẵn",
  预估收益: "Thu nhập ước tính",
  申购上限: "giới hạn đăng ký",
  项目剩余: "mục còn lại",
  "买入后预计*(SGT)开始计算收益。":
    "Dự kiến{0} (SGT) bắt đầu tính thu nhập sau khi mua.",
  计息日: "ngày tính lãi",
  申购日: "ngày đăng ký",
  到账日: "Ngày tới",
  到期自动续投: "Tự động gia hạn khi hết hạn",
  申购: "mua, tựa vào, bám vào",
  搜索理财项目: "Tìm kiếm dự án tài chính",
  超高年化随心选: "Hàng năm cực cao, chọn tùy thích",
  "自由选择理财币种，稳定超额收益":
    "Tự do lựa chọn loại tiền quản lý tài sản, lợi nhuận thặng dư ổn định",
  理财总资产: "Tổng tài sản quản lý tài sản",
  累计收益: "thu nhập tích lũy",
  申购数量: "số lượng đăng ký",
  立即购买: "Mua ngay",
  年化收益率: "Tỷ lệ hoàn vốn hàng năm",
  理财订单: "lệnh tài chính",
  持有: "tổ chức",
  申购份额: "chia sẻ đăng ký",
  到账日期: "Ngày tới",
  申购成功: "Đăng ký theo dõi thành công",
  到期: "trưởng thành",
  是否选择做多: "Bạn có chọn làm thêm không",
  "可用余额为0 不能操作": "Số dư khả dụng là 0 và không thể hoạt động",
  福利中心: "trung tâm phúc lợi",
  奖励记录: "hồ sơ khen thưởng",
  我获取到的奖励: "phần thưởng tôi nhận được",
  总价值: "Tổng giá trị",
  新手任务: "nhiệm vụ mới",
  身份认证: "xác thực",
  身份验证: "xác thực",
  去验证: "để xác minh",
  审核中: "đang được xem xét",
  已验证: "Đã xác minh",
  认证失败: "Quá trình xác thực đã thất bại",
  基础认证: "Chứng chỉ cơ bản",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Xin lưu ý rằng một khi thông tin xác thực được xác minh thì không thể sửa đổi thông tin này, vì vậy hãy đảm bảo điền thông tin chính xác",
  "国家/地区": "quốc gia/khu vực",
  请选择: "xin vui lòng chọn",
  证件类型: "loại giấy chứng nhận",
  证件编码: "mã nhận dạng",
  身份证: "chứng minh thư",
  护照: "hộ chiếu",
  驾驶证: "bằng lái xe",
  请输入编码: "Vui lòng nhập mã",
  名字: "Tên",
  请输入: "vui lòng nhập",
  中间名: "tên đệm",
  选填: "không bắt buộc",
  姓氏: "họ",
  中国: "Trung Quốc",
  身份上传: "tải lên danh tính",
  上传身份证: "tải lên ID",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Các tài liệu trên cần được tải lên ở định dạng JPG/JPEG/PNG và đảm bảo rằng ảnh rõ ràng, đầy đủ và có độ sáng đồng đều. Và kích thước không vượt quá {0}M.",
  确定提交: "xác nhận gửi",
  去认证: "đi xác thực",
  挑战任务: "nhiệm vụ thử thách",
  注册认证任务: "Nhiệm vụ chứng nhận đăng ký",
  完成注册认证即可领取:
    "Sau khi hoàn thành chứng nhận đăng ký, bạn có thể nhận được nó",
  领取奖励: "nhận giải thưởng",
  新人豪礼: "quà tân thủ",
  "参与人数：": "Số lượng người tham gia:",
  条件: "tình trạng",
  入金量: "Số tiền gửi",
  完成: "Kết thúc",
  任务奖励: "phần thưởng nhiệm vụ",
  距任务更新: "cập nhật từ nhiệm vụ",
  "条件：": "tình trạng:",
  活动规则: "quy tắc hoạt động",
  奖励明细: "Chi tiết phần thưởng",
  已获得: "thu được",
  交易奖励: "phần thưởng giao dịch",
  Win奖励: "Giành phần thưởng",
  已领取: "nhận",
  亏损金额超过: "Số tiền thất thoát vượt quá",
  单笔开仓金额超过: "Một số tiền mở một vị trí vượt quá",
  交易量: "Khối lượng giao dịch",
  待完成: "được hoàn thành",
  入金: "Tiền gửi",
  盈利金额超过: "Số tiền lãi vượt quá",
  开仓金额: "số tiền mở",
  开仓金: "Tiền gửi ban đầu",
  盈利: "lợi nhuận",
  亏损: "sự mất mát",
  领取: "nhận",
  未领取: "không xác định",
  待领取: "được thu thập",
  再交易: "giao dịch lại",
  即可获得: "có thể lấy được",
  领取成功: "nhận thành công",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Tất cả các hoạt động sẽ được tính theo lần cuối cùng của hoạt động, sau khi hết hạn thu nhập sẽ không hợp lệ.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Thu nhập thu được sẽ được phân phối vào tài khoản tiền thưởng của bạn và bạn có thể trao đổi và rút tiền mặt bất cứ lúc nào tùy theo nhu cầu của mình.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Loại tiền thưởng thu được sẽ được cấp theo loại nhiệm vụ.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Quyền giải thích cuối cùng thuộc về nền tảng, nếu phát hiện ra các phương pháp bất thường để phân xử phần thưởng nhiệm vụ của nền tảng, nền tảng có quyền đóng băng và xóa thu nhập mà bạn có được.",
  成长学院: "Học viện tăng trưởng",
  区块链: "chuỗi khối",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Hướng dẫn một cửa của bạn về tiền điện tử, chúng tôi sẽ đưa bạn đến với tiền điện tử.",
  "全仓合约定单的全部保证金。":
    "Ký quỹ đầy đủ cho các lệnh hợp đồng ký quỹ chéo.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Số dư tài khoản + (lãi/lỗ thả nổi - phí xử lý - phí qua đêm) = vốn chủ sở hữu / ký quỹ đã sử dụng * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    'Lãi lỗ thả nổi sẽ ảnh hưởng trực tiếp đến "tiền ký quỹ khả dụng", khi lãi lỗ chưa thực hiện tăng thì tiền ký quỹ khả dụng sẽ tăng, lãi lỗ chưa thực hiện sẽ giảm và tiền lãi khả dụng cũng sẽ giảm.',
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Số dư tài khoản - (ký quỹ đã sử dụng) + (lãi/lỗ thả nổi - phí xử lý - phí qua đêm)",
  "注:可继续用于开仓的保证金。":
    "Lưu ý: Số tiền ký quỹ có thể tiếp tục được sử dụng để mở các vị thế.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Số dư tài khoản + (lãi/lỗ thả nổi - phí xử lý - phí qua đêm)",
  "注:当前的资金结余。": "LƯU Ý: Số dư quỹ hiện tại.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Đề cập đến toàn bộ số dư của tài khoản hợp đồng, bao gồm cả số dư không khả dụng.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Lưu ý: Tỷ lệ rủi ro càng cao thì rủi ro càng thấp và tỷ lệ rủi ro càng thấp thì rủi ro càng cao.",
  该功能尚未开发: "Tính năng này chưa được phát triển",
  重置密码: "đặt lại mật khẩu",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Vui lòng nhập 8-20 ký tự, phải chứa chữ cái, số và ký tự đặc biệt",
  修改成功: "sửa đổi thành công",
  输入验证码: "nhập mã xác nhận",
  输入密码: "nhập mật khẩu",
  详情说明: "Thông tin chi tiết",
  已售罄: "Bán hết",
  剩余期限: "thời gian còn lại",
  限期: "đường giới hạn",
  闪兑货币选择: "Lựa chọn tiền tệ tức thì",
  地区选择: "lựa chọn khu vực",
  "搜索国家/地区": "Tìm kiếm quốc gia",
  "身份信息已提交，将在*小时内审核完成":
    "Thông tin nhận dạng đã được gửi và sẽ được xem xét trong vòng {0} giờ",
  "选择国家/地区": "chọn quốc gia",
  "止盈价格需高于*": "Giá chốt lời cần phải cao hơn {0}",
  "止损价格需低于*": "Giá cắt lỗ cần phải thấp hơn {0}",
  "止盈价格需低于*": "Giá chốt lãi phải thấp hơn {0}",
  "止损价格需高于*": "Giá cắt lỗ cần phải cao hơn {0}",
  教程详情: "chi tiết hướng dẫn",
  请输入止损价: "Vui lòng nhập giá dừng",
  活期: "hiện hành",
  赎回后立即到账: "Ngay sau khi chuộc lỗi",
  赎回: "chuộc lỗi",
  赎回理财: "Đổi mới quản lý tài chính",
  是否赎回当前的理财订单: "Có nên chuộc lại trật tự quản lý tài sản hiện tại",
  维护: "duy trì",
  "系统正在维护中……": "Hệ thống đang bảo trì...",
  合约: "hợp đồng",
  闪电兑换: "trao đổi sét",
  流水挖矿: "Khai thác dòng chảy",
  邀请豪礼: "quà mời",
  计算器: "máy tính",
  最新价: "Giá mới nhất",
  涨跌幅: "thay đổi báo giá",
  关注币种添加自选: "Theo dõi tiền tệ và thêm tùy chọn",
  一键添加自选: "Một cú nhấp chuột thêm tùy chọn",
  全标已读: "Tất cả các thẻ đã đọc",
  无消息: "không có tin tức",
  "暂时还没有收到任何消息通知哦!": "Chưa nhận được thông báo nào!",
  没有更多数据: "không còn dữ liệu",
  闪兑: "Tốc biến",
  从: "từ",
  "可用余额：": "Số dư khả dụng:",
  至: "đến",
  预览兑换结果: "Xem trước kết quả trao đổi",
  闪兑规则: "Quy tắc trao đổi flash",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Trao đổi flash thị trường có thể thay đổi, vui lòng tham khảo số tiền thực tế nhận được.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Tỷ giá hối đoái do bên thứ 3 quy định. Do chi phí trao đổi và biến động thị trường, tỷ giá hối đoái bạn trao đổi có thể cao hơn tỷ giá hối đoái thị trường. Vui lòng xác nhận kỹ trước khi thực hiện.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Nền tảng tính phí xử lý khoảng {fee}% cho mỗi lần chuyển tiền, được sử dụng để thanh toán chi phí trao đổi trên sàn giao dịch.",
  确认汇兑: "xác nhận trao đổi",
  您预估得到: "bạn ước tính",
  汇兑: "Trao đổi",
  汇兑比例: "tỷ giá",
  刷新: "để làm mới",
  兑换: "trao đổi",
  没有更多了: "không còn nữa",
  搜索币种: "Tìm kiếm tiền tệ",
  可用: "có sẵn",
  我知道了: "Tôi thấy",
  最新价格: "giá mới nhất",
  确认: "xác nhận",
  最大: "tối đa",
  "风险率(%)": "Tỷ lệ rủi ro (%)",
  持仓: "Chức vụ",
  当前委托: "hoa hồng hiện tại",
  合作交易历史记录: "Lịch sử giao dịch hợp tác",
  重置: "cài lại",
  余额: "THĂNG BẰNG",
  现货账户: "Tài khoản vốn",
  合约账户: "tương lai",
  WIN账户: "thắng lợi",
  赏金账户: "Quà tặng",
  总资产折合: "Tổng tài sản tương đương",
  今日收益: "Thu nhập hôm nay",
  充币: "Tiền gửi",
  提币: "Rút tiền",
  账户权益: "Tài khoản",
  "数量/类别": "Số lượng/Loại",
  全部币种: "Tất cả các loại tiền tệ",
  全部类型: "các loại",
  账单信息: "Thông tin thanh toán",
  理财赎回: "mua lại tài chính",
  购买理财: "mua tiền",
  收入: "thu nhập = earnings",
  支出: "chi phí",
  到: "đến",
  资产划转: "chuyển nhượng tài sản",
  "最少*": "ít nhất*",
  "可用资产：": "Tài sản có sẵn:",
  确认划转: "Xác nhận chuyển khoản",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Chỉ khi tài sản được chuyển vào tài khoản tương ứng, giao dịch mới có thể được thực hiện và không có phí xử lý cho việc chuyển giữa các tài khoản.",
  币种账户选择: "Lựa chọn tài khoản tiền tệ",
  选择账户: "chọn tài khoản",
  划转详情: "Chi tiết chuyển khoản",
  划转明细: "Chi tiết chuyển khoản",
  收入账单: "hóa đơn thu nhập",
  支出账单: "hóa đơn chi tiêu",
  金额: "số tiền",
  总收益: "Tổng doanh thu",
  佣金: "Uỷ ban",
  用户名: "tên tài khoản",
  "已领取：": "Nhận:",
  "未领取：": "không xác định:",
  "请选择国家/地区": "Vui lòng chọn một quốc gia",
  请上传身份信息: "Vui lòng tải lên thông tin nhận dạng",
  请选择证件类型: "Vui lòng chọn một loại tài liệu",
  请填写证件编码: "Vui lòng điền số ID",
  请填写名字: "Vui lòng điền tên",
  请填写姓氏: "Vui lòng điền họ và tên",
  单向持仓: "Vị trí một chiều",
  投资金额: "số tiền đầu tư",
  天: "bầu trời",
  请输入手机号: "Vui lòng nhập số điện thoại",
  搜索: "Tìm kiếm",
  搜索历史: "lịch sử tìm kiếm",
  热门推荐: "khuyến nghị phổ biến",
  "《Xspace Earn协议》": "《Thỏa thuận kiếm tiền Xspace》",
  我已了解并同意: "tôi hiểu và đồng ý",
  协议: "giao thức",
  Xspace官方中文交流群: "Xspace nhóm truyền thông chính thức của Trung Quốc",
  Xspace官方英文交流群: "Nhóm giao tiếp tiếng anh chính thức của Xspace",
  预计维护至: "Dự kiến ​​bảo trì đến",
  更多功能: "Nhiều tính năng hơn",
  下载APP: "Tải ứng dụng",
  理财: "quản lý tài chính",
  推荐: "giới thiệu",
  Telegram官方中文频道: "Telegram kênh chính thức của Trung Quốc",
  Telegram官方英文频道: "Kênh tiếng Anh chính thức của Telegram",
  官方邮箱: "email chính thức",
  客服邮箱: "Email dịch vụ khách hàng",
  上述信息最终解释权归官方所有:
    "Giải thích cuối cùng của các thông tin trên thuộc về quan chức",
  IOS版下载: "Tải xuống phiên bản iOS",
  Android版下载: "Tải xuống cho Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Phí xử lý = Phí xử lý mua + Tỷ lệ tài trợ + Phí xử lý bán",
  资金划转: "chuyển tiền",
  止盈: "thu lợi nhuận",
  止损: "chặn đứng tổn thất",
  自动平仓: "đóng cửa tự động",
  委托挂单: "Ủy thác lệnh chờ",
  买: "mua, tựa vào, bám vào",
  卖: "Bán",
  "买入/做多": "mua/dài",
  "卖出/做空": "bán/ngắn",
  详情: "thông tin chi tiết",
  浮动涨跌: "nổi lên và xuống",
  最小: "nhỏ nhất",
  充币数量: "Số tiền gửi",
  请输入充币数量: "Vui lòng nhập số tiền gửi",
  支付截图: "Ảnh chụp màn hình thanh toán",
  提交: "Gửi đi",
  上传驾驶证: "tải lên giấy phép lái xe",
  上传护照: "tải lên hộ chiếu",
  加载中: "Đang tải",
  上传成功: "tải lên thành công",
  充值历史: "Lịch sử nạp tiền",
  合约卖出手续费: "Phí bán hợp đồng",
  合约买入手续费: "Phí mua hợp đồng",
  系统加款: "Hệ thống thêm tiền",
  系统减款: "Khấu trừ hệ thống",
  合约资金费率: "Tỷ lệ tài trợ hợp đồng",
  佣金分成: "chia sẻ hoa hồng",
  U本位合约: "Hợp đồng tiêu chuẩn U",
  资产管理: "quản lý tài sản",
  APP下载: "Tải xuống",
  全球领先的数字理财平台:
    "Nền tảng quản lý tài sản kỹ thuật số hàng đầu thế giới",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Giao dịch ngay lập tức hàng trăm tài sản kỹ thuật số như Bitcoin và Ethereum",
  "24H涨跌幅": "Tăng giảm 24H",
  查看更多行情: "Xem thêm báo giá",
  近24小时成交量: "Khối lượng giao dịch trong 24 giờ qua",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Cung cấp hàng trăm cặp giao dịch tiền tệ và hợp đồng để đáp ứng nhu cầu giao dịch đa dạng. Nền tảng này có hơn 20 triệu người dùng ở 200 quốc gia và khu vực, đồng thời là nền tảng dịch vụ tài sản kỹ thuật số hàng đầu thế giới.",
  用户国家分布: "Phân phối quốc gia người dùng",
  用户数: "Số người dùng",
  交易对: "cặp giao dịch",
  服务支持: "hỗ trợ dịch vụ",
  "随时随地，多平台终端交易":
    "Mọi lúc, mọi nơi, giao dịch đầu cuối đa nền tảng",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Nó hoàn toàn tương thích với nhiều thiết bị đầu cuối và có thể đáp ứng nhu cầu giao dịch của các tình huống khác nhau bất cứ lúc nào.",
  随时查看实时行情: "Xem thị trường thời gian thực bất cứ lúc nào",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Mua và bán BTC, ETH, DOGE và các tài sản kỹ thuật số khác một cách dễ dàng",
  获取您关注的加密货币价格变化预警:
    "Nhận thông báo về sự thay đổi giá của các loại tiền điện tử mà bạn quan tâm",
  "查看比特币现货、期货、期权价格":
    "Xem giao ngay bitcoin, tương lai, giá quyền chọn",
  比较各交易所加密货币价格: "So sánh giá tiền điện tử trên các sàn giao dịch",
  开启您的数字货币之旅: "Bắt đầu hành trình tiền kỹ thuật số của bạn",
  快捷购买数字货币: "Nhanh chóng mua tiền kỹ thuật số",
  "使用多种支付方式交易数字货币，安全快捷":
    "Sử dụng nhiều phương thức thanh toán để giao dịch tiền kỹ thuật số, an toàn và nhanh chóng",
  最优的交易费率: "Tỷ lệ phí giao dịch tối ưu",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Tỷ giá giao dịch ưu đãi, quyền VIP cạnh tranh, tận hưởng chất lượng dịch vụ tốt nhất",
  可信赖的安全保障: "Bảo mật đáng tin cậy",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Các biện pháp bảo mật tinh vi và quỹ SAFU của chúng tôi bảo vệ tài sản kỹ thuật số của bạn khỏi mọi rủi ro.",
  交易: "buôn bán",
  币币市场: "thị trường tiền tệ",
  "24H成交量": "Khối lượng giao dịch 24H",
  交易所: "trao đổi",
  "24H最高": "cao nhất 24H",
  "24H最低": "tối thiểu 24 giờ",
  永续合约: "hợp đồng vĩnh viễn",
  日涨跌: "Tăng và giảm hàng ngày",
  交易深度: "độ sâu giao dịch",
  "资产(合约)": "Tài sản (hợp đồng)",
  历史仓位: "Vị trí lịch sử",
  兑换记录: "kỷ lục trao đổi",
  类型: "loại hình",
  充值记录: "hồ sơ nạp tiền",
  划转记录: "kỷ lục chuyển nhượng",
  类别: "thể loại",
  历史账单: "hóa đơn lịch sử",
  在线充值: "nạp tiền trực tuyến",
  安全设置: "Cài đặt hệ thống bảo vệ",
  用于账户登录使用: "Để sử dụng đăng nhập tài khoản",
  用户提现时安全验证使用:
    "Được sử dụng để xác minh bảo mật khi người dùng rút tiền mặt",
  验证: "kiểm chứng",
  万: "Mười nghìn",
  随时随地开启交易: "Mở giao dịch mọi lúc, mọi nơi",
  "*货币交易所的所有功能尽在你的手中。":
    "{0} Tất cả các chức năng của trao đổi tiền tệ đều nằm trong tay bạn.",
  "下载*货币交易所APP。": "Tải xuống {0}Ứng dụng trao đổi tiền tệ.",
  下载自: "tải xuống từ",
  内测版: "Bản thử nghiệm",
  下载: "Tải xuống",
  扫码下载: "Quét mã để tải xuống",
  设置您的资产密码: "Đặt mật khẩu tài sản của bạn",
  法币: "tiền tệ Pháp",
  我要买: "tôi muốn mua",
  我要卖: "tôi muốn bán",
  请输入金额: "Vui lòng nhập số tiền",
  汇率: "tỷ giá",
  获得: "lấy",
  支付通道: "kênh thanh toán",
  收款通道: "kênh thanh toán",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Trong quá trình bán hàng, cần phải xác nhận rằng phương thức thanh toán của bạn là của riêng bạn.",
  当前法币暂不支持交易对可尝试前往提现:
    "Đồng tiền hợp pháp hiện tại không hỗ trợ các cặp giao dịch, bạn có thể thử rút tiền",
  前往提现: "chuyển sang tiền mặt",
  该法币暂无通道: "Không có kênh nào cho loại tiền pháp định này",
  "正在出售中，请耐心等待": "Cần bán, hãy kiên nhẫn",
  请选择支付通道: "Vui lòng chọn kênh thanh toán",
  请选择方式: "Vui lòng chọn một phương pháp",
  法币历史: "lịch sử fiat",
  买币: "mua tiền xu",
  卖币: "bán tiền xu",
  失败: "Thất bại",
  已完成: "hoàn thành",
  未付款: "Chưa thanh toán",
  待审核: "để được xem xét",
  打款中: "thanh toán",
  订单详情: "chi tiết đặt hàng",
  联系客服: "liên hệ với dịch vụ khách hàng",
  到账金额: "Số tiền nhận",
  通道: "lối đi",
  收款人: "người nhận tiền",
  收款账户: "Những tài khoản có thể nhận được",
  "订单出售失败，请查下方失败原因":
    "Đơn hàng bán không thành công, vui lòng kiểm tra lý do thất bại bên dưới",
  失败原因: "lý do thất bại",
  您还未进行付款: "Bạn chưa thực hiện thanh toán",
  您已成功购买: "Bạn đã mua thành công",
  已取消订单: "Lệnh hủy",
  "订单正在审核中，请耐心等待":
    "Đơn hàng đang được xem xét, vui lòng kiên nhẫn",
  您已成功出售: "Bạn đã bán thành công",
  "订单正在打款中，请耐心等待":
    "Đơn hàng đang được thanh toán, vui lòng kiên nhẫn chờ đợi",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Quá trình thanh toán yêu cầu bạn phải vào các nền tảng khác để thực hiện lệnh thanh toán, vui lòng chú ý bảo mật thông tin.",
  当前法币暂不支持交易对可尝试前往充值:
    "Đồng tiền hợp pháp hiện tại không hỗ trợ các cặp giao dịch, bạn có thể thử nạp tiền",
  前往充值: "Đi nạp tiền",
  购买: "Mua",
  订单号: "số thứ tự",
  单价: "đơn giá",
  到账数量: "số lượng đến",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Hiện có lệnh chưa thanh toán, bạn có muốn tiếp tục khởi tạo lệnh thanh toán mới không?",
  继续支付: "tiếp tục trả tiền",
  重新下单: "sắp xếp lại",
  是否确定出售: "Bạn có chắc chắn để bán",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Sau khi việc mua bán được xác nhận, nền tảng sẽ được giao cho người mua, vui lòng kiên nhẫn chờ đợi nền tảng khớp lệnh.",
  出售: "bán",
  收款方式: "phương thức thanh toán",
  订单已生成: "Đơn hàng đã được tạo",
  取消订单: "hủy đơn hàng",
  请在: "xin vui lòng tại",
  内完成付款: "hoàn thành thanh toán trong vòng",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注":
    "Rời khỏi nền tảng, đăng nhập vào khoản thanh toán bạn đã chỉ định, chuyển vào tài khoản sau của người bán và nhớ ghi chú trong khoản thanh toán",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Nếu không ghi chú trong quá trình thanh toán, bên bán sẽ không xác nhận được việc đã nhận tiền, dẫn đến thất thoát tài sản không lấy lại được.",
  "未在规定的时间内付款，订单都将被取消。":
    "Nếu thanh toán không được thực hiện trong thời gian quy định, đơn đặt hàng sẽ bị hủy bỏ.",
  姓名: "Tên",
  收款姓名: "Tên người nhận",
  开户支行: "Chi nhánh mở tài khoản",
  银行卡号: "số thẻ ngân hàng",
  "付款后，返回本平台": "Sau khi thanh toán, hãy quay lại nền tảng này",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    'Hãy chắc chắn nhấp vào nút "Tôi đã hoàn tất thanh toán, thông báo cho người bán" bên dưới',
  未点击卖家不会放款: "Người bán sẽ không phát hành tiền mà không cần nhấp vào",
  交易条款: "Điều khoản của giao dịch",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Nguồn tiền mua phải là nguồn tiền hợp pháp và an toàn trước khi giao dịch",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Gian lận, kế hoạch kim tự tháp, cờ bạc hoặc các giao dịch tài chính bất hợp pháp khác đều không được phép",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Sau khi giao dịch hoàn tất, nếu có rủi ro về tiền, tiền bị đóng băng hoặc nghi ngờ gian lận, âm mưu kim tự tháp hoặc cờ bạc, chúng tôi sẽ không phát hành U cho người mua nữa và sẽ hoàn lại tiền",
  "已付款，通知卖家": "Đã thanh toán, thông báo cho người bán",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Nếu người mua hủy tổng cộng {0} đơn hàng trong cùng một ngày, chức năng mua hàng trong ngày sẽ bị hủy. Bạn có chắc chắn hủy đơn hàng này không?",
  添加收款方式: "Thêm phương thức thanh toán",
  是否删除此收款方式: "Có xóa phương thức thanh toán này hay không",
  删除: "xóa bỏ",
  请选择法币: "Vui lòng chọn loại tiền pháp định",
  机构名称: "Tên tổ chức",
  请选择机构: "Vui lòng chọn một tổ chức",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Khi bạn bán tiền kỹ thuật số, phương thức thanh toán bạn chọn sẽ được hiển thị cho người mua, vui lòng xác nhận rằng phương thức thanh toán đó là chính xác.",
  请选择银行: "Vui lòng chọn một ngân hàng",
  请输入姓名: "Vui lòng nhập tên của bạn",
  账号: "tài khoản",
  请输入账号: "vui lòng nhập tài khoản",
  收款码: "mã hóa đơn",
  "银行账号/卡号": "Số tài khoản ngân hàng/số thẻ",
  "请输入银行账号/卡号": "Vui lòng nhập tài khoản ngân hàng/số thẻ",
  "开户支行（选填）": "Chi nhánh mở tài khoản (không bắt buộc)",
  请输入开户支行: "Vui lòng nhập chi nhánh mở tài khoản",
  "加入*官方频道": "Tham gia {0}kênh chính thức",
  关于: "Về",
  条款: "điều kiện",
  其他: "khác",
  成功: "thành công",
  等待: "Chờ đã",
  作废: "khoảng trống",
  确认付款: "xác nhận thanh toán",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Đã thanh toán xong chưa? Nếu thanh toán được xác nhận, người bán sẽ xác nhận xem khoản thanh toán đã được nhận hay chưa trong vòng {0} phút.",
  最大金额: "số tiền tối đa",
  最小金额: "số tiền tối thiểu",
  付款: "Thanh toán",
  法币充值: "Nạp tiền Fiat",
  法币提现: "Rút tiền Fiat",
  待支付: "để được thanh toán",
  已支付: "Trả",
  商户名: "Tên người bán",
  当前没有添加支付方式:
    "Hiện tại không có phương thức thanh toán nào được thêm vào",
  添加后再出售: "thêm để bán",
  新人大礼包: "Người mới tham gia",
  注册即可领取: "Đăng ký để nhận",
  立即领取: "lấy nó ngay bây giờ",
  不再提示: "Đừng nhắc lại",
  "该奖励需在APP中领取，请下载APP":
    "Phần thưởng cần được yêu cầu trong APP, vui lòng tải xuống APP",
  去交易: "để giao dịch",
  期权交易: "giao dịch quyền chọn",
  交易额: "số tiền giao dịch",
  可用额度: "Số lượng có sẵn",
  交易周期: "chu kỳ giao dịch",
  看涨: "lạc quan",
  看跌: "giảm giá",
  当前持有: "hiện đang được tổ chức",
  胜率: "tỷ lệ chiến thắng",
  "盈利/亏损数": "Mất lợi nhuận",
  累计实现盈亏: "Lãi lỗ thực hiện lũy kế",
  秒: "thứ hai",
  分: "Phút",
  小时: "Giờ",
  天: "bầu trời",
  周: "tuần",
  下单时间: "thời gian phục vụ",
  剩余时间: "thời gian còn lại",
  买入价: "giá mua",
  结算价: "Giá thanh toán",
  实现盈利: "thu được lợi nhuận",
  结算时间: "thời gian giải quyết",
  期权: "tùy chọn",
  新手教程: "Hướng dẫn cho người mới bắt đầu",
  我的订单: "Đơn hàng của tôi",
  赔率: "tỷ lệ cược",
  全部订单: "tất cả các đơn đặt hàng",
  持有订单: "giữ trật tự",
  历史订单: "trật tự lịch sử",
  输入交易额度: "Nhập số tiền giao dịch",
  选择交易周期: "Chọn một chu kỳ giao dịch",
  去注册: "đăng ký",
  冻结: "Đông cứng",
  期权支出: "xuất chi tùy chọn",
  期权收入: "thu nhập tùy chọn",
  用户提现: "Rút tiền của người dùng",
  "是否购买？": "Bạn có muốn mua?",
  购买成功: "mua hàng thành công",
  请签名: "ký, xin vui lòng",
  提交签名: "gửi chữ ký",
  清空签名: "chữ ký rõ ràng",
  签名审核中: "xem xét chữ ký",
  已提交: "đệ trình",
  扫一扫下载APP: "Quét để tải xuống ỨNG DỤNG",
  新手领取大礼包: "Người mới nhận được cuộc vui",
  注册实名即送彩金: "Đăng ký tên thật và nhận tiền thưởng",
  交易总额: "tổng số tiền giao dịch",
  资产不足: "không đủ tài sản",
  "Win账户的资产不足，可从现货账户划转至此账户":
    "Tài khoản Win không đủ tài sản và có thể chuyển từ tài khoản vốn sang tài khoản này",
  Win: "thắng lợi",
  在线充值: "nạp tiền trực tuyến",
  比赛: "Cuộc thi",
  未开始: "chưa bắt đầu",
  赛程: "lịch trình",
  赛果: "Kết quả",
  已结束: "kết thúc",
  让球: "chấp",
  进球数: "Bàn thắng",
  大: "To lớn",
  小: "Nhỏ bé",
  胜负平: "buộc",
  和局: "Buộc",
  投注: "cá cược",
  下注金额: "số tiền đặt cược",
  下注: "đặt cược",
  阵容: "xếp hàng",
  分析: "phân tích",
  输入下注金额: "Nhập số tiền đặt cược",
  下注成功: "đặt cược thành công",
  投注记录: "kỷ lục cá cược",
  未结算: "bất ổn",
  已结算: "Định cư",
  流水: "nước chảy",
  输赢: "thắng hay thua",
  赛时: "thời gian trò chơi",
  下注时间: "thời gian cá cược",
  足彩竞猜: "cá cược bóng đá",
  查看详情: "kiểm tra các chi tiết",
  输: "mất",
  赢: "thắng lợi",
  主: "chủ nhà",
  客: "khách mời",
  主胜: "chiến thắng chính",
  客胜: "khách thắng",
  平: "bằng phẳng",
  已延期: "hoãn lại",
  账号异常: "tài khoản bất thường",
  全场独赢: "Người chiến thắng",
  全场让球: "khuyết tật",
  全场大小: "kích thước đầy đủ",
  总进球: "tổng số mục tiêu",
  拍摄照片要求: "yêu cầu chụp ảnh",
  标准拍摄: "bắn tiêu chuẩn",
  边框缺失: "thiếu biên giới",
  照片模糊: "ảnh mờ",
  闪光强烈: "đèn flash mạnh",
  上传手持证件照: "Tải ảnh hộ chiếu lên",
  上传证件照: "Tải lên ảnh ID",
  换一张: "thay đổi một",
  出生日期: "ngày sinh",
  请选择出生日期: "Vui lòng chọn ngày sinh",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Sau khi nhập đúng xác minh bằng hình ảnh bên dưới, hãy lấy mã xác minh email để đăng ký",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Bạn vẫn còn {0} số lần xác thực, quá số lần này bạn sẽ không thể tiếp tục xác thực",
  上半场: "nửa đầu",
  下半场: "một nửa thứ hai",
  独赢: "chiến thắng một mình",
  上半场独赢: "thắng hiệp một",
  下半场独赢: "thắng hiệp hai",
  上半场让球: "chấp hiệp một",
  下半场让球: "chấp hiệp hai",
  上半场大小球: "Bàn thắng trong hiệp một",
  下半场大小球: "Bàn thắng hiệp 2",
  波胆: "cholesterol",
  上半场波胆: "tỷ số hiệp một",
  下半场波胆: "tỷ số hiệp hai",
  单双: "Đơn và đôi",
  上半场单双: "Kèo tài xỉu hiệp 1",
  下半场单双: "Tỷ lệ cược và nhân đôi trong hiệp hai",
  总进球: "tổng số mục tiêu",
  上半场总进球: "Tổng số bàn thắng trong hiệp 1",
  下半场总进球: "Tổng số bàn thắng trong hiệp hai",
  单: "một",
  双: "đôi",
  中场: "tiền vệ",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Lưu ý: Các bạn làm theo hình mẫu này để viết chữ trên giấy trắng và chụp ảnh kèm theo CMND",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Gần đây, một số lượng lớn tài khoản gian lận đã bị phát hiện và một loạt tài khoản bất hợp pháp đã bị trừng phạt. Nếu bất kỳ tài khoản nào bị đánh giá sai là tài khoản bất hợp pháp, vui lòng liên hệ với dịch vụ khách hàng trực tuyến.",
  最小下注金额: "số tiền đặt cược tối thiểu",
  参与活动最小下注金额: "Số tiền đặt cược tối thiểu để tham gia hoạt động",
  记住密码: "nhớ mật khẩu",
  比分: "ghi bàn",
  "您还未登录，请先登录": "Bạn chưa đăng nhập, vui lòng đăng nhập trước",
  立即登录: "đăng nhập ngay lập tức",
  下注限额: "giới hạn cá cược",
  可赢金额: "số tiền có thể kiếm được",
  闪兑详情: "Chi tiết Flash",
  大小球: "kích thước bóng",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Do tỷ giá hối đoái, có thể có sự khác biệt giữa số tiền đặt cược và số tiền đặt cược thực tế, vui lòng tham khảo đơn đặt hàng.",
  开赛时间: "thời gian bắt đầu",
  足球收入: "thu nhập bóng đá",
  足球支出: "chi tiêu bóng đá",
  活动详情: "chi tiết hoạt động",
  为世界杯喝彩: "cổ vũ cho cúp thế giới",
  我的竞猜: "tôi đoán",
  "竞猜比赛、有机会瓜分*USDT": "Đoán trò chơi và có cơ hội chia sẻ {0}USDT",
  "瓜分*USDT": "Chia {0}USDT",
  距离活动结束还有: "Vẫn còn thời gian cho đến khi kết thúc sự kiện",
  我的门票: "vé của tôi",
  竞猜结束时间: "Đoán thời gian kết thúc",
  猜比分: "Đoán tỷ số",
  "福利派送中，完成任务即可获取门票":
    "Phân phát phúc lợi đang được tiến hành, hoàn thành nhiệm vụ để nhận vé",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Hoàn thành các nhiệm vụ sau, bạn có thể nhận được số lượng vé tương ứng để tham gia cuộc thi",
  时: "Thời gian",
  活动: "Hoạt động",
  竞猜记录: "Kỷ lục đoán",
  结果: "kết quả",
  任务: "Nhiệm vụ",
  去邀请: "mời",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Tỷ số mỗi trận đấu cạnh tranh, tham gia cạnh tranh có thể chia phần thưởng ${0}.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Tham gia bài kiểm tra yêu cầu vé, có thể nhận được theo các nhiệm vụ của nền tảng.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的现货账户，你可以立即提取。":
    "Sau khi phỏng đoán thành công, gửi ảnh chụp màn hình kết quả phỏng đoán cho nhân viên phục vụ, nhân viên phục vụ sẽ đưa tiền thưởng vào tài khoản tài chính của bạn, bạn có thể rút ngay.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Mọi gian lận đều bị cấm và phần thưởng sẽ bị vô hiệu nếu phát hiện gian lận.",
  "完成任务后，点击咨询客服获得门票。":
    "Sau khi hoàn thành nhiệm vụ, bấm vào Tư vấn dịch vụ khách hàng để lấy vé.",
  继续猜: "tiếp tục đoán",
  总单数: "tổng số ít",
  赛事筛选: "sàng lọc sự kiện",
  球队筛选: "lựa chọn đội",
  总金额: "một lần",
  总流水: "tổng doanh thu",
  派奖金额: "số tiền thưởng",
  下注单数: "Cược số lẻ",
  利润: "lợi nhuận",
  更多福利: "nhiều lợi ích hơn",
  我的奖金: "tiền thưởng của tôi",
  未认证: "không công nhận, không chứng nhận",
  总量: "Tổng cộng",
  或: "hoặc",
  模拟交易: "giao dịch demo",
  体验账户不可操作: "Tài khoản trải nghiệm không hoạt động",
  世界杯比分竞猜: "Câu đố tỷ số World Cup",
  "领*USDT起": "Nhận {0}USDT từ",
  消息: "thông tin",
  滚球: "Bóng lăn",
  是: "Phải.",
  不是: "không",
  当前余额: "số dư hiện tại",
  KOL招募: "tuyển KOL",
  本月净输赢: "Lãi/lỗ ròng trong tháng",
  本月佣金: "hoa hồng của tháng",
  佣金比例: "tỷ lệ hoa hồng",
  活跃人数: "số hoạt động",
  新增下级: "thêm cấp dưới",
  登录人数: "số lần đăng nhập",
  首存人数: "Số lượng người gửi tiền lần đầu",
  数据分析: "phân tích dữ liệu",
  人数: "số người",
  新注册存款金额: "Số tiền gửi đăng ký mới",
  老用户存款金额: "Số tiền gửi của người dùng cũ",
  首存金额: "Số tiền gửi đầu tiên",
  快捷入口: "nhập nhanh",
  成员管理: "quản lý thành viên",
  财务报表: "Báo cáo tài chính",
  分红报表: "báo cáo cổ tức",
  订单记录: "hồ sơ đặt hàng",
  VIP专享: "VIP độc quyền",
  推广工具: "công cụ khuyến mãi",
  计算规则: "Quy tắc tính toán",
  账变明细: "Chi tiết thay đổi tài khoản",
  成员: "hội viên",
  下级概览: "tổng quan cấp dưới",
  下级成员总计: "Thành viên cấp dưới Tổng cộng",
  本月新增: "mới trong tháng này",
  本月活跃会员: "Thành viên tích cực của tháng",
  今日活跃会员: "Thành viên tích cực hôm nay",
  本月有效活跃: "hoạt động trong tháng này",
  活跃成员占比: "Tỷ lệ thành viên tích cực",
  本月活跃: "hoạt động trong tháng này",
  今日活跃: "hoạt động ngày hôm nay",
  下级成员: "thành viên cấp dưới",
  会员账号: "tài khoản thành viên",
  统计时间: "Thời gian thống kê",
  筛选: "lọc",
  存款: "đặt cọc",
  取款: "rút tiền",
  总输赢: "tổng số tiền thắng hoặc thua",
  是否有效用户: "Đó có phải là người dùng hợp lệ không",
  最近登录时间: "lần đăng nhập cuối cùng",
  否: "không",
  开始时间: "thời gian bắt đầu",
  结束时间: "Thời gian kết thúc",
  提取: "trích xuất",
  总盈亏: "tổng lãi lỗ",
  净盈亏: "lãi và lỗ ròng",
  分红: "cổ tức",
  概览: "tổng quát",
  月度详细数据: "Dữ liệu chi tiết hàng tháng",
  未发放: "không được ban hành",
  活跃用户: "người dùng đang hoạt động",
  有效新增会员: "Thêm thành viên mới hiệu quả",
  冲正后净输赢: "Thắng hoặc thua ròng sau khi xả",
  上月结余: "Số dư tháng trước",
  净输赢: "thắng/thua ròng",
  "系统每日新加坡时间1:00更新一次报表":
    "Hệ thống cập nhật báo cáo hàng ngày lúc 1:00 giờ Singapore",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "Số dương trong dữ liệu, tổng số tiền thắng và thua cũng như số tiền thắng và lỗ ròng trong báo cáo cho biết lợi nhuận của đại lý và số âm cho biết khoản lỗ của đại lý",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Dữ liệu hoa hồng được cập nhật mỗi ngày và chỉ mang tính chất tham khảo, không phải là tiêu chuẩn phân chia hoa hồng thực tế",
  选择时间: "thời gian lựa chọn",
  足球: "bóng đá",
  投注金额: "số tiền đặt cược",
  有效订单: "đơn đặt hàng hợp lệ",
  下级账户: "Tài khoản cấp dưới",
  待成交: "giao dịch đang chờ xử lý",
  下单金额: "số lượng đơn đặt hàng",
  订单内容: "nội dung đặt hàng",
  秒数: "giây",
  联赛: "giải đấu",
  队伍: "đội",
  比赛时间: "thời gian thi đấu",
  玩法: "cách chơi",
  等级规则表: "Bảng quy tắc lớp",
  等级: "cấp",
  活跃会员: "thành viên tích cực",
  最新活跃: "hoạt động mới nhất",
  额外佣金: "hoa hồng thêm",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Tiêu chuẩn tăng trưởng và hệ thống phần thưởng của cấp độ tương ứng được thực hiện hàng tháng và chỉ có thể nhận được phần thưởng ở một cấp độ.",
  渠道生成: "tạo kênh",
  创建: "tạo ra",
  渠道名称: "Tên kênh",
  注册人数: "số lượng người đăng ký",
  浏览人数: "Những người xem",
  构建状态: "trạng thái xây dựng",
  禁用: "Vô hiệu hóa",
  启用: "cho phép",
  查看: "Kiểm tra",
  创建渠道: "tạo kênh",
  创建成功: "tạo thành công",
  操作成功: "Hoạt động thành công",
  渠道详情: "Chi tiết kênh",
  邀请码: "Mã mời",
  访问人数: "số lượng khách",
  渠道地址: "địa chỉ kênh",
  我的福利: "lợi ích của tôi",
  充值福利: "Lợi ích nạp tiền",
  当前流水: "dòng chảy hiện tại",
  如何参与: "Làm thế nào để tham gia",
  币种充值: "nạp tiền",
  充值福利中领取福利: "Nhận ưu đãi từ ưu đãi nạp tiền",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Quy tắc: Quyền lợi nạp tiền là tự nguyện nhận, thời hạn hiệu lực là trong vòng 24 giờ sau khi nạp tiền, hết hạn sẽ mất hiệu lực, sau khi nhận sẽ tạm khóa chức năng rút tiền, rút ​​tiền có thể được mở khóa sau khi đạt được doanh thu.",
  失效日期: "ngày hết hạn",
  "暂无福利领取，充值后领取": "Chưa có lợi ích để nhận, nhận sau khi nạp tiền",
  参与: "tham gia",
  充值赠送: "nạp quà tặng",
  "领取*%的赠送": "Nhận {0}% quà tặng",
  去领取: "để thu thập",
  VIP奖励: "phần thưởng VIP",
  "当前可领取*USDT，是否确认领取":
    "Hiện tại có thể nhận {0}USDT, bạn có xác nhận yêu cầu không?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Sau khi yêu cầu, chức năng rút tiền sẽ tạm thời bị khóa và khóa có thể được mở khóa khi doanh thu của bạn đạt {0}USDT",
  充值送大礼: "Nạp tiền nhận quà lớn",
  "存入越多，送越多！": "Bạn càng ký gửi nhiều, bạn càng nhận được nhiều!",
  无效: "không hợp lệ",
  有效: "có hiệu quả",
  总存金额: "tổng số tiền gửi",
  提示: "gợi ý",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Số dương trong tổng số tiền thắng và thua cũng như số tiền thắng và thua ròng biểu thị lợi nhuận của nền tảng và số âm biểu thị thua lỗ. Dữ liệu hàng ngày chỉ mang tính tham khảo và không đóng vai trò là tiêu chuẩn phân phối hoa hồng thực tế.",
  "净盈亏：总盈亏-用户返水":
    "Lãi và lỗ ròng: tổng lãi lỗ - giảm giá cho người dùng",
  盈利方: "Bên có lợi nhuận",
  代理: "diễn xuất",
  客户: "khách hàng",
  平局: "vẽ tranh",
  平台: "nền tảng",
  "已提交审核，请耐心等待": "Đã gửi để xem xét, hãy kiên nhẫn",
  充值日期: "ngày nạp tiền",
  平台本月总输赢: "Tổng số tiền thắng và thua của nền tảng trong tháng này",
  KOL招募合作: "Hợp tác tuyển dụng KOL",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Nền tảng hiện đang mở [Sự kiện tuyển dụng KOL], miễn là bạn có tài khoản mạng xã hội, bạn có thể tận hưởng phần thưởng một lần với nền tảng để quảng bá khách hàng và bạn có thể hưởng lợi ích trọn đời.",
  级别: "cấp độ",
  平台利润返佣: "Giảm giá lợi nhuận nền tảng",
  佣金案例: "trường hợp hoa hồng",
  交易项目: "mặt hàng giao dịch",
  "期权交易、合约交易、足球游戏":
    "Giao dịch quyền chọn, giao dịch hợp đồng, trò chơi bóng đá",
  报名方式: "các cách đăng ký",
  点击KOL招募报名: "Click đăng ký tuyển dụng KOL",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Chào mừng bạn tham gia nhóm của chúng tôi, nền tảng hoàn toàn hỗ trợ bạn thiết lập hệ thống người dùng của riêng mình và bạn có thể nhận được hoa hồng{0} cao nhất, chúng tôi rất mong bạn tham gia.",
  输入联系方式: "Nhập thông tin liên hệ",
  最低活跃人数: "Số hoạt động tối thiểu",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Ví dụ: số lượng người dùng hoạt động trong tháng này ≥ {0} và tổng số tiền thắng hoặc thua của nền tảng trong tháng này ≥ {1}USDT, bạn thuộc cấp độ {2}, bạn có thể nhận được {3}% hoa hồng.",
  比分竞猜: "Tỷ số cạnh tranh",
  豪礼相赠: "Quà tặng",
  足球活动: "Hoạt động bóng đá",
  圣诞节活动: "Sự kiện Giáng sinh",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Bạn đã tham gia sự kiện, tính năng rút tiền tạm thời khóa và bạn có thể mở khóa bằng cách sử dụng dòng chảy {0}USDT.",
  剩余流水: "Nước còn lại",
  助力足球: "Trợ giúp bóng đá",
  佣金累计: "Tổng hoa hồng",
  有效投注: "đặt cược hợp lệ",
  今日: "Hôm nay",
  今日返水: "Giảm giá hôm nay",
  VIP返水: "Giảm giá VIP",
  返水记录: "Hồ sơ giảm giá",
  成员信息: "Thông tin thành viên",
  基本信息: "Thông tin cơ bản",
  钱包余额: "Số dư ví",
  投注信息: "Thông tin cá cược",
  返水: "Hạ giá",
  总下注: "Tổng cược",
  今日输赢: "Thắng hay thua hôm nay",
  下注动态: "Động lực cá cược",
  返水奖励: "Tiền thưởng giảm giá",
  分红金额: "Số tiền cổ tức",
  返水支出: "Xuất chi giảm giá",
  总返水: "Tổng giảm giá",
  流水总额: "Tổng doanh thu",
  返水总额: "Tổng số tiền hoàn lại",
  返水详情: "Chi tiết chiết khấu",
  日流水: "Nước hàng ngày",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Nền tảng cung cấp phần thưởng chiết khấu bổ sung dựa trên doanh thu hàng ngày của cấp dưới của bạn và phần thưởng sẽ được phân phối vào tài khoản phần thưởng vào lúc 00:00 giờ Singapore mỗi ngày",
  "申请成功，等待审核": "Ứng dụng đã thành công, đang chờ xem xét",
  "我出本金，盈利共分享": "Tôi trả tiền gốc và chia lợi nhuận",
  最高分红: "cổ tức cao nhất",
  投资大师比赛: "Cuộc thi bậc thầy đầu tư",
  "我出本金，你盈利": "Tôi trả tiền gốc, bạn lãi",
  共分享: "chia sẻ",
  最高分红可得: "Cổ tức tối đa có sẵn",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Sắp có các lợi ích dành riêng cho người dùng mới, ${0} miễn phí, bạn có thể đầu tư vào bất kỳ dự án nào trên nền tảng sau khi nhận được và có thể rút ngay sau khi kiếm được lợi nhuận.",
  报名领取: "Đăng ký để nhận",
  已领取: "nhận",
  审核驳回: "Đánh giá bị từ chối",
  驳回原因: "Lý do từ chối",
  活动运行周期: "Chu kỳ chạy hoạt động",
  "申请成功后起至*天内完成超额收益。":
    "Sau khi đăng ký thành công, thu nhập vượt quá sẽ được hoàn thành trong vòng {0} ngày.",
  分红比: "tỷ lệ cổ tức",
  "*日获得盈利后，可获得*%的收益额。":
    "Sau khi kiếm được lợi nhuận vào {0} ngày, bạn có thể nhận được {1}% lợi nhuận.",
  参与条件: "điều kiện tham gia",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Người dùng ở Nga và Thổ Nhĩ Kỳ đã không tham gia.",
  计算项目: "hạng mục tính toán",
  "合约、体育、期权": "Hợp đồng, Thể thao, Tùy chọn",
  我的投资: "khoản đầu tư của tôi",
  参与天数: "ngày tham gia",
  累计下注: "cược tích lũy",
  累计盈亏: "Lãi lỗ lũy kế",
  预计可分红: "Dự kiến ​​chia cổ tức",
  常见问题: "vấn đề thường gặp",
  什么是平台出资: "tài trợ nền tảng là gì",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Theo người dùng ở một số quốc gia, nền tảng này cung cấp tiền miễn phí để người dùng đầu tư vào các dự án.",
  怎么获取平台出资的福利:
    "Làm thế nào để có được những lợi ích của việc đóng góp nền tảng",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Bạn chỉ cần là người dùng ở một quốc gia được chỉ định, nhấp vào nút đăng ký ở trên và {0}USDT sẽ được chuyển vào tài khoản tiền thưởng trong tài khoản hiện tại sau khi quá trình xem xét nền tảng hoàn tất và bạn có thể chuyển nó sang các tài khoản khác để đầu tư.",
  什么是分红: "cổ tức là gì",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Cổ tức có nghĩa là trong một khoảng thời gian xác định, sau khi thu nhập đạt 100%, 50% thu nhập vượt quá có thể được chia. Ví dụ: Để nhận tiền 100USDT, số tiền thu nhập là 120%.",
  "如何取得分红？": "Làm thế nào để có được cổ tức?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Chu kỳ hoạt động là {0} ngày một lần. Sau khi hoạt động kết thúc, nó sẽ được tính toán và cổ tức sẽ được phân phối cho tài khoản tiền thưởng sau khi đáp ứng các yêu cầu của hoạt động. Nếu bạn không đáp ứng các yêu cầu hoạt động, hệ thống sẽ tự động xóa thu nhập và đóng góp nền tảng của bạn.",
  活动规则: "Nội quy hoạt động",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Các tài khoản tham gia cần phải trải qua quá trình xác minh KYC và mỗi tài khoản được giới hạn ở một lợi ích.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC của các tài khoản tham gia yêu cầu quốc gia được chỉ định tham gia và các khu vực khác không được phép tham gia. Vui lòng kiểm tra xem quốc gia đang hoạt động có nhất quán với quốc gia của bạn hay không.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Sau khi tham gia hoạt động thành công, tài khoản sẽ tạm thời khóa chức năng rút tiền của bạn và chức năng rút tiền của bạn sẽ được giải phóng sau khi hoạt động hoàn thành.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Vui lòng tuân thủ các quy tắc hoạt động của nền tảng. Nếu bạn phát hiện gian lận hoặc lợi dụng sơ hở của hệ thống để trục lợi, nền tảng sẽ đóng băng tất cả tiền trong tài khoản của bạn trong một thời gian dài.",
  平台出资: "Đầu tư nền tảng",
  平台出资收回: "Thu hồi đầu tư nền tảng",
  投资大师奖励: "Giải thưởng bậc thầy đầu tư",
  请下载APP添加收款方式:
    "Vui lòng tải xuống APP để thêm phương thức thanh toán",
  请下载APP进行身份验证: "Vui lòng tải xuống APP để xác minh danh tính",
  请下载APP参与: "Vui lòng tải APP để tham gia",
  技术指标: "Chỉ số kỹ thuật",
  主图: "Hình ảnh chính",
  副图: "Hình ảnh phụ",
  新注册人数: "Người đăng ký mới",
  老用户存款人数: "Tiền gửi của người dùng cũ",
  存款人数: "Số lượng người gửi tiền",
  取款人数: "Số lần rút tiền",
  投注人数: "Số người đặt cược",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Ngoại trừ Indonesia, Ấn Độ, Bangladesh và những người dùng chưa tham gia.",
  市场动态: "Động lực thị trường",
  外汇合约: "hợp đồng ngoại hối",
  盈亏比: "tỷ lệ lãi lỗ",
  委托价: "Giá đặt hàng",
  可用余额: "Số dư khả dụng",
  持仓额: "Số tiền vị thế",
  强平价: "Tính chẵn lẻ mạnh mẽ",
  修改: "Ôn lại",
  修改价位: "Sửa đổi giá",
  外汇: "Ngoại hối",
  外汇账户: "Tài khoản ngoại hối",
  我的交易: "giao dịch của tôi",
  未设置: "không được thiết lập",
  超出最大可设数值: "Vượt quá giá trị có thể cài đặt tối đa",
  超出最小可设数值: "Vượt quá giá trị có thể cài đặt tối thiểu",
  止盈超出最小可设数值: "Chốt lời vượt quá giá trị có thể đặt tối thiểu",
  止损超出最大可设数值: "Dừng lỗ vượt quá giá trị có thể cài đặt tối đa",
  止盈超出最大可设数值: "Chốt lời vượt quá giá trị có thể cài đặt tối đa",
  止损超出最小可设数值: "Dừng lỗ vượt quá giá trị có thể đặt tối thiểu",
  挖矿: "Khai thác mỏ",
  交易账户: "tài khoản giao dịch",
  买涨: "mua lên",
  买跌: "Mua hoặc bán",
  请输入正确的银行卡信息: "Vui lòng nhập chính xác thông tin thẻ ngân hàng",
  联系在线客服: "Liên hệ với dịch vụ khách hàng trực tuyến",
  法币交易请联系在线客服:
    "Đối với các giao dịch tiền tệ hợp pháp, vui lòng liên hệ với dịch vụ khách hàng trực tuyến",
  提交订单: "Nộp đơn đặt hàng",
  "支付过程如有疑问,请联系在线客服":
    "Nếu bạn có bất kỳ câu hỏi nào về quá trình thanh toán, vui lòng liên hệ với bộ phận dịch vụ khách hàng trực tuyến",
  彩金赠送: "Tiền thưởng.",
  在线客服: "dịch vụ trực tuyến",
  最少投资: "đầu tư tối thiểu",
  "提交时间:": "Thời gian nộp hồ sơ:",
  提现拒绝: "Rút tiền bị từ chối",
  认证拒绝: "Xác thực bị từ chối",
  认证通过: "Chứng nhận đã được thông qua",
  请输入正确的交易额度: "Vui lòng nhập đúng số tiền giao dịch",
  最大下注金额: "Số tiền đặt cược tối đa",
  手机号: "Số điện thoại",
  邮箱注册: "đăng ky email",
  手机号注册: "Đăng ký số điện thoại di động",
  查询: "Hỏi thăm",
  手机号登录: "Đăng nhập số điện thoại di động",
  邮箱登录: "Đăng nhập email",
  请输入数量: "Vui lòng nhập số lượng",
  可用数量: "Số lượng hiện có sẵn",
  钱包登录: "Đăng nhập ví",
  请输入正确的邀请码: "Vui lòng nhập đúng mã mời",
  "请输入邀请码(必填)": "Vui lòng nhập mã mời (bắt buộc)",
  输入正确的金额: "Nhập đúng số tiền",
  法币充值: "Nạp tiền bằng đồng tiền quốc gia",
  卢比充值: "Nạp Rupi",
  请输入法币: "Vui lòng nhập tiền tệ",
  请输入IFSC: "Vui lòng nhập mã IFSC",
  "银行编码(选填)": "Mã ngân hàng (tùy chọn)",
  请输入银行编码: "Vui lòng nhập mã ngân hàng",
  请输入大于8位数的密码: "Vui lòng nhập mật khẩu lớn hơn 8 chữ số",
  添加成功: "Thêm thành công",
  "60秒": "60 giây",
  "180秒": "180 giây",
  "300秒": "300 giây",
  "2次密码不一致": "2 mật khẩu không nhất quán",
  输入提币数量: "Nhập số tiền rút",
  图片格式不正确: "Định dạng hình ảnh không chính xác",
  图片大于20M: "Hình ảnh lớn hơn 20M",
  请设置委托价格: "Vui lòng đặt giá ủy thác",
  输入资金密码: "Nhập mật khẩu tài chính",
  验证码错误: "Doğrulama kodu hatası",
  充值拒绝: "Nạp tiền bị từ chối",
  请输入SSN: "Vui lòng nhập SSN",
  合约交易: "giao dịch hợp đồng",
  结算完成: "Thanh toán hoàn tất",
  继续下单: "Tiếp tục đặt hàng",
  最低购买: "mua tối thiểu",
  最高购买: "mua cao nhất",
  限价: "Giá Hạn",
  买入价格: "Giá Mua",
  买入量: "Số Lượng Mua",
  卖出价格: "Giá Bán",
  卖出量: "Số Lượng Bán",
  买入: "Mua",
  卖出: "Bán",
  订单创建成功: "Đặt Hàng Thành Công",
  币币买入支出: "Chi Phí Mua Crypto",
  币币买入支出退还: "Hoàn Trả Chi Phí Mua Crypto",
  币币买入获得: "Crypto Nhận Được Từ Mua",
  币币卖出支出: "Chi Phí Bán Crypto",
  币币卖出支出退还: "Hoàn Trả Chi Phí Bán Crypto",
  币币卖出获得: "Crypto Nhận Được Từ Bán",
  币币交易手续费: "Phí Giao Dịch Crypto",
  请输入限价: "Vui Lòng Nhập Giá Hạn",
  成交: "Hoàn Tất",
  等待成交: "Đang Chờ Hoàn Tất",
  交易完成: "Giao Dịch Đã Hoàn Tất",
  被取消: "Đã Hủy",
  交易时间: "Thời Gian Giao Dịch",
  法币交易: "Giao dịch tiền tệ pháp định",
  法币出售: "Bán tiền tệ pháp định",
  两次密码不一致: "Hai mật khẩu không khớp",
  再次输入账户密码: "Nhập lại mật khẩu tài khoản",

  美国: "Hoa Kỳ",
  韩国: "Hàn Quốc",
  阿尔巴尼亚: "Albania",
  津巴布韦: "Zimbabwe",
  赞比亚: "Zambia",
  也门: "Yemen",
  美属维尔京群岛: "Quần đảo Virgin thuộc Mỹ",
  英属处女群岛: "Quần đảo Virgin thuộc Anh",
  越南: "Việt Nam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Uzbekistan",
  乌拉圭: "Uruguay",
  英国: "Vương quốc Anh",
  阿拉伯联合酋长国: "Các Tiểu Vương quốc Ả Rập Thống nhất",
  乌克兰: "Ukraina",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Quần đảo Turks và Caicos",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Thổ Nhĩ Kỳ",
  突尼斯: "Tunisia",
  特立尼达和多巴哥: "Trinidad và Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Đông Timor",
  泰国: "Thái Lan",
  坦桑尼亚: "Tanzania",
  塔吉克斯坦: "Tajikistan",
  中国台湾: "Đài Loan (Trung Quốc)",
  叙利亚: "Syria",
  瑞士: "Thụy Sĩ",
  瑞典: "Thụy Điển",
  斯威士兰: "Eswatini",
  苏里南: "Suriname",
  苏丹: "Sudan",
  斯里兰卡: "Sri Lanka",
  西班牙: "Tây Ban Nha",
  南非: "Nam Phi",
  索马里: "Somalia",
  所罗门群岛: "Quần đảo Solomon",
  斯洛文尼亚: "Slovenia",
  斯洛伐克: "Slovakia",
  "圣马丁岛（荷兰部分）": "Saint Martin (phần Hà Lan)",
  新加坡: "Singapore",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychelles",
  塞尔维亚: "Serbia",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Ả Rập Xê-út",
  圣多美和普林西比: "São Tomé và Príncipe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "Saint Kitts và Nevis",
  圣文森特和格林纳丁斯: "Saint Vincent và Grenadines",
  圣彼埃尔和密克隆岛: "Saint Pierre và Miquelon",
  圣露西亚: "Saint Lucia",
  圣基茨和尼维斯: "Saint Kitts và Nevis",
  卢旺达: "Rwanda",
  俄罗斯: "Nga",
  罗马尼亚: "Romania",
  留尼汪: "Réunion",
  刚果共和国: "Cộng hòa Congo",
  卡塔尔: "Qatar",
  波多黎各: "Puerto Rico",
  葡萄牙: "Bồ Đào Nha",
  波兰: "Ba Lan",
  菲律宾: "Philippines",
  秘鲁: "Peru",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papua New Guinea",
  巴拿马: "Panama",
  巴勒斯坦: "Palestine",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Na Uy",
  尼日利亚: "Nigeria",
  尼日尔: "Niger",
  尼加拉瓜: "Nicaragua",
  新西兰: "New Zealand",
  新喀里多尼亚: "Nouvelle-Calédonie",
  荷属安德列斯群岛: "Antilles thuộc Hà Lan",
  荷兰: "Hà Lan",
  尼泊尔: "Nepal",
  纳米比亚: "Namibia",
  缅甸: "Myanmar",
  莫桑比克: "Mozambique",
  摩洛哥: "Maroc",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Montenegro",
  蒙古: "Mông Cổ",
  摩纳哥: "Monaco",
  摩尔多瓦: "Moldova",
  墨西哥: "Mexico",
  马约特: "Mayotte",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mauritania",
  马里亚纳群岛: "Quần đảo Mariana",
  马提尼克: "Martinique",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Maldives",
  马来西亚: "Malaysia",
  马拉维: "Malawi",
  马达加斯加: "Madagascar",
  马其顿: "Bắc Macedonia",
  中国澳门: "Macau (Trung Quốc)",
  卢森堡: "Luxembourg",
  立陶宛: "Litva",
  列支敦士登: "Liechtenstein",
  利比亚: "Libya",
  利比里亚: "Liberia",
  莱索托: "Lesotho",
  黎巴嫩: "Lebanon",
  拉脱维亚: "Latvia",
  老挝: "Lào",
  吉尔吉斯斯坦: "Kyrgyzstan",
  科威特: "Kuwait",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenya",
  哈萨克斯坦: "Kazakhstan",
  约旦: "Jordan",
  日本: "Nhật Bản",
  牙买加: "Jamaica",
  象牙海岸: "Bờ Biển Ngà",
  意大利: "Ý",
  以色列: "Israel",
  爱尔兰: "Ireland",
  伊拉克: "Iraq",
  伊朗: "Iran",
  印度尼西亚: "Indonesia",
  印度: "Ấn Độ",
  冰岛: "Iceland",
  匈牙利: "Hungary",
  中国香港: "Hồng Kông (Trung Quốc)",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Guiné-Bissau",
  几内亚: "Guinea",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Grenada",
  格陵兰岛: "Greenland",
  希腊: "Hy Lạp",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Đức",
  格鲁吉亚: "Georgia",
  冈比亚: "Gambia",
  加蓬: "Gabon",
  法属波利尼西亚: "Polynesia thuộc Pháp",
  法属圭亚那: "Guiana thuộc Pháp",
  法国: "Pháp",
  芬兰: "Phần Lan",
  斐济: "Fiji",
  法罗群岛: "Quần đảo Faroe",
  埃塞俄比亚: "Ethiopia",
  爱沙尼亚: "Estonia",
  厄立特里亚: "Eritrea",
  赤道几内亚: "Guinea Xích Đạo",
  萨尔瓦多: "El Salvador",
  埃及: "Ai Cập",
  厄瓜多尔: "Ecuador",
  多米尼加共和国: "Cộng hòa Dominica",
  多米尼加: "Dominica",
  吉布提: "Djibouti",
  丹麦: "Đan Mạch",
  捷克: "Séc",
  塞浦路斯: "Síp",
  库拉索: "Curaçao",
  古巴: "Cuba",
  克罗地亚: "Croatia",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Côte d'Ivoire",
  库克群岛: "Quần đảo Cook",
  科摩罗: "Comoros",
  哥伦比亚: "Colombia",
  智利: "Chile",
  乍得: "Chad",
  中非共和国: "Cộng hòa Trung Phi",
  佛得角: "Cabo Verde",
  开曼群岛: "Quần đảo Cayman",
  开普: "Cape",
  加拿大: "Canada",
  喀麦隆: "Cameroon",
  柬埔寨: "Campuchia",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgaria",
  文莱: "Brunei",
  巴西: "Brazil",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bosnia và Herzegovina",
  玻利维亚: "Bolivia",
  不丹: "Bhutan",
  百慕大群岛: "Bermuda",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Bỉ",
  白俄罗斯: "Belarus",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladesh",
  巴林: "Bahrain",
  巴哈马: "Bahamas",
  阿塞拜疆: "Azerbaijan",
  奥地利: "Áo",
  澳大利亚: "Úc",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenia",
  阿根廷: "Argentina",
  安提瓜和巴布达: "Antigua và Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Samoa thuộc Mỹ",
  阿尔及利亚: "Algeria",
  中国: "Trung Quốc",

  日收益: "Lợi nhuận hàng ngày",
  "30天预期收益": "Lợi nhuận dự kiến 30 ngày",
  英伟达高速矿机: "Máy đào tốc độ cao NVIDIA",
  去投资: "Đi đầu tư",
  新币榜: "Bảng xếp hạng tiền mới",
  主题: "Chủ đề",
  立即探索: "Khám phá ngay",
  等您来: "Chờ bạn đến",
  最新活动: "Hoạt động mới nhất",
  货币划转: "Chuyển tiền tệ",
  提现钱包: "Ví rút tiền",
  加密合约: "Hợp đồng mã hóa",
  外汇期货: "Hợp đồng tương lai ngoại hối",
  定期: "Kỳ hạn",
  探索产品: "Khám phá sản phẩm",
  稳健型: "Loại ổn định",
  高收益: "Lợi nhuận cao",
  期货账户: "Tài khoản hợp đồng tương lai",
  时间线: "Đường thời gian",
  收藏: "Yêu thích",
  委托订单: "Đơn hàng ủy thác",
  最新交易: "Giao dịch mới nhất",
  深度图: "Biểu đồ độ sâu",
  标记价格: "Giá đánh dấu",
  "24h最高价": "Giá cao nhất 24h",
  "24h成交量": "Khối lượng giao dịch 24h",
  "24h最低价": "Giá thấp nhất 24h",
  "24h成交额": "Tổng giá trị giao dịch 24h",
  "价格(USDT)": "Giá (USDT)",
  "数量(ETH)": "Số lượng (ETH)",
  看空: "Phát hiện giảm giá",
  余额不足: "Số dư không đủ",
  最低购买: "Mua tối thiểu",
  最高购买: "Mua tối đa",
  下单成功: "Đặt hàng thành công",
  平仓成功: "Đóng vị thế thành công",
  请输入正确的平仓数量: "Vui lòng nhập số lượng đóng vị thế chính xác",
  加仓成功: "Tăng vị thế thành công",
  请输入正确的加仓金额: "Vui lòng nhập số tiền tăng vị thế chính xác",
  收藏成功: "Thêm vào yêu thích thành công",
  取消收藏成功: "Xóa khỏi yêu thích thành công",
  日收益率: "Tỷ suất lợi nhuận hàng ngày",
  轻松理财: "Quản lý tài chính dễ dàng",
  立即申购: "Đăng ký mua ngay",
  申购日期: "Ngày đăng ký mua",
  加密货币: "Tiền điện tử mã hóa",
  交割合约: "Hợp đồng giao hàng",
  最小投资: "Đầu tư tối thiểu",
  委托: "Ủy thác",
  "当指数价格触达时，将会触发委托平仓":
    "Khi giá chỉ số đạt đến mức, sẽ kích hoạt đóng vị thế ủy thác",
  预计盈利: "Lợi nhuận dự kiến",
  最大投资: "Đầu tư tối đa",
  现货交易: "Giao dịch crypto",
  输入交易金额: "Nhập số tiền giao dịch",
  "可用额度：": "Ngưỡng sử dụng được:",
  提现货币: "Tiền tệ rút tiền",
  期货合约: "Hợp đồng tương lai",
  加密币永续: "Vĩnh cửu Crypto",
  外汇永续: "Vĩnh cửu Forex",
  期权账户: "Tài khoản quyền chọn",
  夜间模式: "Chế độ ban đêm",
  未结盈亏: "Lợi nhuận và thua lỗ chưa thực hiện",
  超额收益: "Lợi nhuận vượt mức",
  "安全策略，低买高卖": "Chiến lược bảo mật, mua thấp bán cao",
  投资金额应为: "Số tiền đầu tư sẽ là",
  总收益率: "Tổng lợi nhuận",
  赎回成功: "Redemption thành công",
  快捷卖币: "Bán nhanh",
  修改止盈止损: "Chỉnh sửa TP/SL",
  白皮书: "Sách trắng",
  托管资金: "Vốn quản lý",
  托管中: "Đang quản lý",
  预计日收益: "Thu nhập hàng ngày dự kiến",
  累计收益: "Tổng thu nhập",
  周期: "Chu kỳ",
  日收益: "Thu nhập hàng ngày",
  限额: "Giới hạn",
  立即托管: "Đầu tư ngay",
  "已鎖定 請聯繫客服": "Đã bị khóa, vui lòng liên hệ chăm sóc khách hàng",
  产品列表: "Danh sách sản phẩm",
  规则: "Quy tắc",
  创建订单: "Tạo đơn hàng",
  产品名称: "Tên sản phẩm",
  托管周期: "Chu kỳ quản lý",
  等级限制: "Giới hạn cấp độ",
  托管金额: "Số tiền đầu tư",
  限额: "Giới hạn",
  余额: "Số dư",
  购买日: "Ngày mua",
  起息日: "Ngày bắt đầu tính lãi",
  派息时间: "Thời gian chia lợi nhuận",
  每天: "Mỗi ngày",
  计息结束日: "Ngày kết thúc tính lãi",
  每日收益: "Thu nhập hàng ngày",
  预计收益: "Thu nhập dự kiến",
  "收益将自动发送至您的余额账户;":
    "Lợi nhuận sẽ tự động được gửi vào tài khoản số dư của bạn;",
  "您的资金没有任何风险;": "Tiền của bạn hoàn toàn không có rủi ro;",
  "365*24小时不断地工作;": "Hoạt động 24/7, 365 ngày mỗi năm;",
  托管中: "Đang quản lý",
  结束: "Kết thúc",
  今日收益: "Thu nhập hôm nay",
  剩余周期: "Chu kỳ còn lại",
  进行中: "Đang thực hiện",
  已发放: "Đã chi trả",
  信誉分: "Điểm danh tiếng",

  复制成功: "Sao chép thành công",
  VIP权益: "Quyền lợi VIP",
  旧密码: "Mật khẩu cũ",
  请输入旧密码: "Vui lòng nhập mật khẩu cũ",
  "忘记旧密码请联系客服重置。":
    "Nếu bạn quên mật khẩu cũ, vui lòng liên hệ bộ phận chăm sóc khách hàng để đặt lại.",
  去升级: "Nâng cấp",
  描述: "Mô tả",
  实际存款金额: "Số tiền nạp thực tế",
  升级礼金: "Tiền thưởng nâng cấp",
  隔夜利息: "Lãi qua đêm (swap)",
  自动结算: "Thanh toán tự động",
  等级规则: "Quy tắc cấp độ",
  "WEB3.0币持有数据收益": "Lợi suất dữ liệu nắm giữ coin WEB3.0",
  总生产: "Tổng sản lượng",
  有效节点: "Node hoạt động",
  参与人: "Người tham gia",
  用户收益: "Lợi suất người dùng",
  "流动性WEB3.0输出": "Đầu ra thanh khoản WEB3.0",
  总资产: "Tổng tài sản",

  ETHAI持有数据收益: "Lợi suất dữ liệu nắm giữ ETHAI",
  AI量化流动性: "Thanh khoản định lượng AI",
  现货买入手续费: "Phí mua spot",
  现货支出: "Chi tiêu spot",
  现货资金费率: "Tỷ lệ tài trợ spot",
  现货卖出手续费: "Phí bán spot",
  现货收入: "Thu nhập spot",
  外汇合约支出: "Chi tiêu hợp đồng ngoại hối",
  外汇合约买入手续费: "Phí mua hợp đồng ngoại hối",
  外汇合约资金费率: "Tỷ lệ tài trợ hợp đồng ngoại hối",
  外汇合约卖出手续费: "Phí bán hợp đồng ngoại hối",
  外汇合约收入: "Thu nhập từ hợp đồng ngoại hối",
  理财购买: "Mua sản phẩm quản lý tài sản",
  VIP理财日收益: "Lợi suất hàng ngày của sản phẩm quản lý tài sản VIP",
  VIP理财隔夜利息: "Lãi qua đêm của sản phẩm quản lý tài sản VIP",
  VIP本金返还: "Hoàn trả vốn gốc VIP",
  VIP彩金发放: "Phát thưởng VIP",
  VIP彩金抵扣: "Khấu trừ thưởng VIP",
  隔夜利息: "Lãi qua đêm",
  设置资产密码: "Đặt mật khẩu tài sản",

  锁仓挖矿: "Khai thác khóa",
  一站式理财服务: "Dịch vụ tài chính trọn gói",
  产品: "Sản phẩm",
  客服中心: "Trung tâm chăm sóc khách hàng",
  贷款: "Khoản vay",
  挖矿赚不停: "Kiếm lợi nhuận liên tục từ khai thác",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Khai thác khóa là việc gửi USDT (USD:1USDT=1USD) vào các máy đào có công suất cao của nền tảng để tạo lợi nhuận trong pool khai thác.",
  产品优势: "Ưu điểm sản phẩm",
  随存随取: "Gửi và rút bất cứ lúc nào",
  锁仓周期: "Thời gian khóa",
  每日下发: "Phân phối hàng ngày",
  随机空投: "Airdrop ngẫu nhiên",
  "100%资金安全保障": "100% bảo đảm an toàn vốn",
  "100%节假日收益不间断": "Lợi nhuận không gián đoạn 100% kể cả ngày lễ",
  成功锁仓后当天产出: "Sinh lợi ngay trong ngày sau khi khóa thành công",
  关于违约金: "Về phí phạt",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Nếu bạn rút vốn trước khi đáo hạn, sẽ bị tính phí phạt. Phí phạt = tỷ lệ phạt × số ngày còn lại × số tiền khóa.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Ví dụ: tỷ lệ phạt là 5%, còn 3 ngày, số tiền khóa là 10000U (USDT/USD). Phí phạt = 5%×3×10000=1500U, số tiền thực nhận là 15000U-1500U.",
  收益计算: "Tính lợi nhuận",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Nền tảng cung cấp nhiều sản phẩm tài chính khai thác khóa. Cách tính lợi nhuận như sau, ví dụ:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Nếu người dùng khóa 10000U (USDT, USD) và chọn sản phẩm 7 ngày với lợi nhuận 0,7%~1,8% mỗi ngày, lợi nhuận hàng ngày như sau:",
  "最低:10000Ux0.7%=70U;": "Tối thiểu: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Tối đa: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Sau 7 ngày có thể nhận lợi nhuận 490U~1260U. Lợi nhuận được trả hàng ngày và vốn sẽ tự động chuyển về tài khoản khi đáo hạn.",
  正在托管的资金: "Quỹ đang quản lý",
  签到: "Điểm danh",
  锁仓订单: "Đơn khóa",
  预计今日收益: "Dự kiến lợi nhuận hôm nay",
  累计收益: "Tổng lợi nhuận",
  托管中的订单: "Đơn đang quản lý",
  单笔最少: "Tối thiểu mỗi lệnh",
  单笔最多: "Tối đa mỗi lệnh",
  日收益率: "Tỷ suất lợi nhuận hàng ngày",
  说明: "Giải thích",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Dữ liệu theo múi giờ GMT+8<br>2. Lợi nhuận hàng ngày tính từ các lệnh đã thanh toán trong 00:00-23:59 GMT+8<br>3. Lợi nhuận được phân phối vào ngày hôm sau 00:00-00:10 GMT+8.",
  知道了: "Đã hiểu",
  锁仓: "Khóa",
  派息时间: "Thời gian trả thưởng",
  每日: "Hàng ngày",
  托管资金: "Quỹ quản lý",
  到期返回: "Hoàn vốn khi đáo hạn",
  提前赎回: "Rút trước hạn",
  预计收益: "Lợi nhuận dự kiến",
  认购: "Đăng ký",
  热门: "Phổ biến",
  数字货币: "Tiền điện tử",
  贵金属: "Kim loại quý",
  大宗商品: "Hàng hóa",
  持仓明细: "Chi tiết vị thế",
  历史明细: "Lịch sử",
  当前价: "Giá hiện tại",
  "↑买涨": "↑ Mua tăng",
  "↓买跌": "↓ Mua giảm",
  显示全部: "Hiển thị tất cả",
  买入金额: "Số tiền mua",
  方向: "Hướng",
  收益: "Lợi nhuận",
  预期收益: "Lợi nhuận dự kiến",
  估用保证金: "Ký quỹ ước tính",
  确认下单: "Xác nhận đặt lệnh",
  锁定: "Đã khóa",
  账户总资产: "Tổng tài sản",
  明细: "Chi tiết",
  今日收益: "Lợi nhuận hôm nay",
  仓位保证金: "Ký quỹ vị thế",
  持有仓位: "Vị thế đang giữ",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Số tiền khóa = tổng tất cả các đơn khai thác khóa chưa hoàn tất",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Dữ liệu theo GMT+8<br>2. Lợi nhuận hàng ngày tính từ các lệnh đã thanh toán",
  充值方式: "Phương thức nạp tiền",
  银行汇款: "Chuyển khoản ngân hàng",
  "银行汇款请联系客服进行操作!":
    "Vui lòng liên hệ CSKH để thực hiện chuyển khoản ngân hàng!",
  提款方式: "Phương thức rút tiền",
  "银行提款请联系客服进行操作!":
    "Vui lòng liên hệ CSKH để thực hiện rút tiền ngân hàng!",
  资金明细: "Chi tiết vốn",
  提现记录: "Lịch sử rút tiền",
  拒绝: "Từ chối",
  通过: "Duyệt",
  拒绝原因: "Lý do từ chối",

  消息公告: "Thông báo",
  订单: "Đơn hàng",
  个人中心: "Trung tâm cá nhân",
  "未到期赎回需支付一定的违约金!": "Rút trước hạn sẽ phải trả phí phạt.",

  请输入区号: "Vui lòng nhập mã vùng",
  "请选择国家/地区": "Vui lòng chọn quốc gia/khu vực",

  今日开盘: "Mở cửa hôm nay",
  昨日收盘: "Đóng cửa hôm qua",

  实名认证即送: "Nhận ngay sau khi xác minh danh tính",
  立即认证: "Xác minh ngay",
  新用户礼包: "Gói quà tặng người dùng mới",
  完成新人任务领取: "Hoàn thành nhiệm vụ người dùng mới để nhận",
  认证: "Xác minh",
  时间周期: "Khoảng thời gian",
  支付金额: "Số tiền thanh toán",
  已平仓: "Đã đóng lệnh",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "Gói chào mừng người dùng mới MGBX: Mỗi người dùng có thể nhận tối đa",
  我已经阅读并同意: "Tôi đã đọc và đồng ý",
  隐私政策: "Chính sách bảo mật",
  放弃奖励离开: "Từ bỏ phần thưởng và rời đi",
  继续注册: "Tiếp tục đăng ký",
  分钟: "Phút",
  "请先勾选隐私政策!": "Vui lòng xem qua Chính sách Quyền riêng tư trước!",

  添加其他到自选: "Thêm các mục khác vào Danh sách theo dõi",

  充值最高可得: "Nạp thêm và nhận tới 30.000 USD.",

  请输入格式正确的手机号: "Vui lòng nhập số điện thoại di động hợp lệ.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 越南



// WEBPACK FOOTER //
// ./src/lang/vi.js